import axios from 'axios';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Storage } from 'aws-amplify';
import { JSEncrypt } from "jsencrypt";
import Select from 'react-select';
import { Button, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { CommonLoading } from 'react-loadingg';
import { Fragment, useEffect, useState } from 'react';
import DownloadIcon from '../../images/download-icon.svg';
import EditIcon from '../../images/edit-icon.svg';
import { useLocation, useHistory } from 'react-router-dom';
import SearchUserByEC from '../SearchUserByEC/SearchUserEC';

import "./ResignationForm.css";
import ResubmitModal from './ResignationModal';
import CryptoJS from 'crypto-js';


//Last physical working date and last drawn salary date contains public holiday that needs to be updated yearly as well as 5th week Saturday Working Group around line 533 and 711
const ResignationForm = (props) => {

    const [isLoading, setIsLoading] = useState(true);
    const [openChgSuperiorDialog, setOpenChgSuperiorDialog] = useState(false);

    //Applicant Details
    const optionCounter = [
        { value: '1', label: 'Yes' },
        { value: '0', label: 'No' },
    ]

    //  Short Notice Option
    const shortNoticeOption = [
        { value: '1', label: 'Yes' },
        { value: '0', label: 'No' },
        { value: '2', label: '24 hours resignation' }
    ]



    // Declaration of state variables
    const currentUserID = localStorage.getItem('badgeID');
    const [formID, setFormID] = useState();
    const [currentFormStatus, setCurrentformstatus] = useState();
    const [applicantID, setApplicantID] = useState();
    const [applicantIDSalary, setApplicantIDSalary] = useState();
    const [applicantUserName, setApplicantUserName] = useState();
    const [applicantName, setApplicantName] = useState();
    const [applicantEmail, setApplicantEmail] = useState();
    const [applicantPosition, setApplicantPosition] = useState();
    const [applicantHireDate, setApplicantHireDate] = useState();
    const [applicantServiceLength, setApplicantServiceLength] = useState();
    const [applicantPayGrade, setApplicantPayGrade] = useState();
    const [applicantWorkLocation, setApplicantWorkLocation] = useState();
    const [applicantCompanyCode, setApplicantCompanyCode] = useState();
    const [applicantPayrollFactory, setApplicantPayrollFactory] = useState();
    const [applicantPayrollFactoryBank, setApplicantPayrollFactoryBank] = useState();
    const [applicantPayrollFactoryAccNo, setApplicantPayrollFactoryAccNo] = useState();
    const [applicantSaturdayGroup, setApplicantSaturdayGroup] = useState();
    const [applicantSaturdayCode, setApplicantSaturdayCode] = useState();
    const [applicantSalary, setApplicantSalary] = useState();
    const [selectedOption, setSelectedOption] = useState();
    const [counter, setCounter] = useState();
    const [counterText, setCounterText] = useState();
    const [counterValue, setCountervalue] = useState([]);
    const [counterRemark, setCounterRemark] = useState([]);
    const [counterRemarkStatus, setCounterRemarkStatus] = useState(false);
    const [selectedWaive, setSelectedWaive] = useState();
    const [noticeWaive, setNoticeWaive] = useState();
    const [noticeWaiveText, setNoticeWaiveText] = useState();
    const [noticeWaiveRemark, setNoticeWaiveRemark] = useState([]);
    const [noticeWaiveRemarkStatus, setNoticeWaiveRemarkStatus] = useState(false);
    const [shortNoticePaymentID, setShortNoticePaymentID] = useState(0);
    const [shortNoticePaymentName, setShortNoticePaymentName] = useState();
    const [resignationAttachment, setResignationAttachment] = useState();
    const [resubmittedRemark, setResubmittedRemark] = useState();

    //Table Variable
    const [lastWorkingDate, setLastworkingdate] = useState();
    const [resignationDate, setResignationdate] = useState();
    const [noticePeriod, setNoticeperiod] = useState([]);
    const [noticePeriodMonth, setNoticeperiodmonth] = useState(true);
    const [noticePeriodNone, setNoticeperiodNone] = useState(false);
    const [resignationDatewithNotice, setResignationdatewithnotice] = useState();
    const [resignationDatewithNoticeV2, setResignationdatewithnoticeV2] = useState();

    // const [shortNoticeGiven, setShortnoticegiven] = useState(false);
    const [shortNoticeGiven, setShortnoticegiven] = useState(0);

    const [shortNotice, setShortnotice] = useState([]);
    const [shortNoticeTrue, setShortnoticeTrue] = useState([]);
    const [leaveDays, setLeavedays] = useState([]);
    const [lastPhysicalWorkingDate, setLastPhysicalWorkingDate] = useState([]);
    const [lastDrawnSalaryDate, setLastDrawnSalaryDate] = useState([]);
    const [halfDayLeave, setHalfDayLeave] = useState(false);
    const [lastphysicalSaturday, setLastPhysicalSaturday] = useState(false);
    const [lastdrawnSalarySaturday, setLastDrawnSalarySaturday] = useState(false);


    //Mini table variable
    const [monthDuration, setMonthDuration] = useState([]);
    const [monthArray, setMonthArray] = useState([]);
    const [monthdayArray, setMonthDayArray] = useState([]);
    const [basicSalaryArray, setbasicSalaryArray] = useState([]);
    const [shortdayArray, setShortdayArray] = useState([]);
    const [deductionSalaryArray, setDeductionSalaryArray] = useState([]);
    const [deductionTotal, setDeductionTotal] = useState([]);
    const [tableInfoList, setTableInfoList] = useState([]);

    //Edit
    const [editStatus, setEditStatus] = useState(false);
    const [lastWorkDateEmpStatus, setLastWorkDateEmpStatus] = useState(false);
    const [lastWorkDateEmp, setLastWorkDateEmp] = useState([]);
    const [editLastSalaryRemarkStatus, setEditLastSalaryRemarkStatus] = useState(false);
    const [editLastSalaryRemark, setEditLastSalaryRemark] = useState([]);
    const [editBasicSalaryRemarkStatus, setEditBasicSalaryRemarkStatus] = useState(false);
    const [editBasicSalaryRemark, setEditBasicSalaryRemark] = useState([]);
    const [editLastWorkingDayStatus, setEditLastWorkingDayStatus] = useState(false);
    const [editLastWorkingDayRemark, setEditLastWorkingDayRemark] = useState([]);
    const [editFinalCreatedDateStatus, setEditFinalCreatedDateStatus] = useState(false);
    const [editFinalCreatedDateRemark, setEditFinalCreatedDateRemark] = useState([]);

    //Email
    const [pdfForApprove, setPDFforApprove] = useState([]);
    const [payrollEmail, setPayrollEmail] = useState([]);
    const [superiorEmail, setSuperiorEmail] = useState([]);
    const [superiorName, setSuperiorName] = useState([]);

    const [superiorBadgeid, setSuperiorBadgeId] = useState('');
    const [superiorUserName, setSuperiorUsername] = useState([]);

    //Modal
    const [resubmitModal, setResubmitModal] = useState(false);
    const handleResubmitModal = () => setResubmitModal(!resubmitModal);
    const [notiToken, setNotiToken] = useState([]);

    // Switching Short Notice
    const [leaveUtilisedEditable, setLeaveUtilisedEditable] = useState(false);
    const [openShortNoticePayment, setOpenShortNoticePayment] = useState(false);
    const [shortNoticePaymentList, setShortNoticePaymentList] = useState([]);
    const [newShortNoticeDisplay, setNewShortNoticeDisplay] = useState(false);

    // Encryption key
    const [encryptionKeyAdmin, setEncryptionKeyAdmin] = useState("");
    const [encryptionKey, setEncryptionKey] = useState("");

    const { REACT_APP_API_BACKEND_URL, REACT_APP_PRIVATE_KEY_RESIGNATION } = process.env;

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Resignation') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            }
        }

    }, [props.loginList]);


    //Initialize set basic data
    useEffect(() => {
        if (!location.state) {
            window.stop();
            alert('Please access this page by selecting a user from the resignation list');
            window.location = '/resignation';
        }
        else {
            //!====== hidden comment 
            console.log("RESIGNATION DETAILS HERE !!!");
            console.log(location.state.rowData);
            setFormID(location.state.rowData.formID);
            setCurrentformstatus(location.state.rowData.formStatusID);
            setApplicantID(location.state.rowData.userID);
            setApplicantUserName(location.state.rowData.userIDName);
            setApplicantEmail(location.state.rowData.userEmail);
            setApplicantSaturdayCode(location.state.rowData.workingSaturdayCode);
            setApplicantSaturdayGroup(location.state.rowData.workingSaturdayName);
            setSuperiorName(location.state.rowData.superiorName.toLowerCase());
            setSuperiorUsername(location.state.rowData.superiorUserName);
            setSuperiorEmail(location.state.rowData.superiorEmail);
            setResignationAttachment(location.state.rowData.attachment);
            setShortNoticePaymentID(location.state.rowData.shortNoticePaymentID);
            setShortNoticePaymentName(location.state.rowData.shortNoticePaymentName);
            setResubmittedRemark(location.state.rowData.rejectRemark);
            setEncryptionKeyAdmin(location.state.rowData.encryptionKeyAdmin);
            setEncryptionKey(location.state.rowData.encryptionKey);

            if (location.state.rowData.counteredAdminStatus == 1) { // Countered by Admin (hr_resign_form_admin)
                setCounter(location.state.rowData.counteredAdminStatus);


                const encryptedCounteredValue = CryptoJS.enc.Base64.parse(location.state.rowData.counteredAdminValue);
                const adminSecretKey = CryptoJS.enc.Utf8.parse(location.state.rowData.encryptionKeyAdmin);
                const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

                const bytes = CryptoJS.AES.decrypt(CryptoJS.lib.CipherParams.create({ ciphertext: encryptedCounteredValue }), adminSecretKey, {
                    keySize: 16,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });

                const decryptedCounteredValue = bytes.toString(CryptoJS.enc.Utf8)

                setCountervalue(decryptedCounteredValue);

                setCounterRemark(location.state.rowData.counteredAdminRemark);
                if (location.state.rowData.counteredAdminRemark) {
                    setCounterRemarkStatus(true);
                }
                if (location.state.rowData.counteredAdminStatus == 1) {
                    setSelectedOption({ value: '1', label: 'Yes' })
                    setCounterText("Yes")
                }
                else {
                    setSelectedOption({ value: '0', label: 'No' })
                    setCounterText("No")
                }
            }
            else {
                setCounter(location.state.rowData.counteredStatus);


                const encryptedCounteredValue = CryptoJS.enc.Base64.parse(location.state.rowData.counteredValue);
                const secretKey = CryptoJS.enc.Utf8.parse(location.state.rowData.encryptionKey);
                const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

                const bytes = CryptoJS.AES.decrypt(CryptoJS.lib.CipherParams.create({ ciphertext: encryptedCounteredValue }), secretKey, {
                    keySize: 16,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                });

                const decryptedCounteredValue = bytes.toString(CryptoJS.enc.Utf8)
                setCountervalue(decryptedCounteredValue);

                setCounterRemark(location.state.rowData.counteredRemark);
                if (location.state.rowData.counteredRemark) {
                    setCounterRemarkStatus(true);
                }
                if (location.state.rowData.counteredStatus == 1) {
                    setSelectedOption({ value: '1', label: 'Yes' })
                    setCounterText("Yes")
                }
                else {
                    setSelectedOption({ value: '0', label: 'No' })
                    setCounterText("No")
                }
            }
            if (location.state.rowData.formStatusID == 3 || location.state.rowData.formStatusID == 4) {
                if (location.state.rowData.finalCreatedDateAdminRemark !== "") {
                    setEditFinalCreatedDateStatus(true);
                    setEditFinalCreatedDateRemark(location.state.rowData.finalCreatedDateAdminRemark);
                }
                if (location.state.rowData.lastWorkingDateAdminRemark !== "") {
                    setLastWorkDateEmpStatus(true);
                    setLastWorkDateEmp(location.state.rowData.lastWorkingDateAdminRemark);
                }
                if (location.state.rowData.lastSalaryDateAdminRemark !== "") {
                    setEditLastSalaryRemarkStatus(true);
                    setEditLastSalaryRemark(location.state.rowData.lastSalaryDateAdminRemark);
                }
                if (location.state.rowData.salaryRemark !== "") {
                    setEditBasicSalaryRemarkStatus(true);
                    setEditBasicSalaryRemark(location.state.rowData.salaryRemark)
                }
                if (location.state.rowData.lastPhysicalDateRemark !== "") {
                    setEditLastWorkingDayStatus(true);
                    setEditLastWorkingDayRemark(location.state.rowData.lastPhysicalDateRemark)
                }
                if (location.state.rowData.finalCreatedDateAdmin !== "") {
                    setResignationdate(location.state.rowData.finalCreatedDateAdmin);
                }
                else {
                    setResignationdate(location.state.rowData.createdDate);
                }
                setLastworkingdate(location.state.rowData.lastWorkingDateEmployeeAdmin);
                setLastDrawnSalaryDate(location.state.rowData.lastSalaryDateAdmin);
                setLastPhysicalWorkingDate(location.state.rowData.lastPhysicalDate);

                if(location.state.rowData.salary !== "" && location.state.rowData.encryptionKeyAdmin !== ""){
                    const encryptedSalary = CryptoJS.enc.Base64.parse(location.state.rowData.salary);
                    const secretKey = CryptoJS.enc.Utf8.parse(location.state.rowData.encryptionKeyAdmin);
                    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
    
                    //!====== hidden console.log()
                    // console.log("CipherText (Base64):", location.state.rowData.salary);
                    // console.log("Key (UTF-8):", location.state.rowData.encryptionKeyAdmin);
                    // console.log("IV (Hex):", iv.toString(CryptoJS.enc.Hex));
                    // console.log("CipherText Without IV Length:", encryptedSalary.sigBytes - 16);
    
                    //todo here
                    const bytes = CryptoJS.AES.decrypt(CryptoJS.lib.CipherParams.create({ ciphertext: encryptedSalary }), secretKey, {
                        keySize: 16,
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7,
                    }
                    );
    
                    if (bytes.sigBytes === 0) {
                        throw new Error("Decryption failed. Possibly incorrect key, IV, or ciphertext.");
                    }
                    const decryptedSalaryStr = bytes.toString(CryptoJS.enc.Utf8);
    
                    if (!decryptedSalaryStr) {
                        throw new Error("Decryption returned an empty string.");
                    }
                    const basicsalarylistadmin = decryptedSalaryStr.split(',');
                    setbasicSalaryArray(basicsalarylistadmin);
                }
                
                setNoticeWaive(location.state.rowData.noticeWaiveStatus);
                if (location.state.rowData.noticeWaiveStatus === "1") {
                    setNoticeWaiveText("Yes");
                    setNoticeWaiveRemarkStatus(true);
                    setNoticeWaiveRemark(location.state.rowData.noticeWaiveRemark);
                }
                else {
                    setNoticeWaiveText("No");
                }
            }
            else {
                setLastworkingdate(location.state.rowData.lastWorkingDate);
                setResignationdate(location.state.rowData.createdDate);
            }
            // if (location.state.rowData.leaveUtilize == 1) {
            //     setLeavedays(location.state.rowData.leaveUtilizeDay);
            // }
            // else {
            //     setLeavedays(0);
            // }
            if (location.state.rowData.shortNotice == 1 || location.state.rowData.shortNotice == 2) { 
                // setShortnoticegiven(true);
                setShortnoticegiven(location.state.rowData.shortNotice);
                if (location.state.rowData.leaveUtilize == 1) {
                    setLeavedays(location.state.rowData.leaveUtilizeDay);
                } else {
                    setLeavedays(0);
                }
            }
            else {
                setShortnotice(0);
                setLeavedays(0);
            }
            if (location.state.rowData.formStatusID == 2) {
                setSelectedWaive({ value: '0', label: 'No' });
                setNoticeWaive('0');
            }
        }
    }, [location]);


    // To get Short Notice Payment Option List
    useEffect(() => {
        if (applicantID) {

            const url = REACT_APP_API_BACKEND_URL + '/api/resignation/getResignatonDetails';
            axios.post(url, { userID: applicantID }).then((response) => {

                const paymentOptions = response.data.PaymentList.map(payment => ({
                    value: payment.id,
                    label: payment.name
                }));
                setShortNoticePaymentList(paymentOptions);
            }).catch((err) => console.error(err));
        }
    }, [applicantID]);


    useEffect(() => {
        if (applicantUserName) {
            getResignApplicantDetailwithUserName();
        }
    }, [applicantUserName]);

    async function getResignApplicantDetailwithUserName() {
        if (applicantUserName) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/getResignApplicantDetail';
            axios
                .post(url, { badgeID: applicantUserName })
                .then((response) => {
                    if (response.data.status === 0) {
                        getResignApplicantDetailwithBadgeID()
                    }
                    else {

                        if (response.data.Result.employeeNoticePeriod.toLowerCase().includes("month")) {
                            setNoticeperiod(parseInt(response.data.Result.employeeNoticePeriod.substring(0, 2)));
                        }
                        else if (response.data.Result.employeeNoticePeriod.toLowerCase().includes("week")) {
                            setNoticeperiodmonth(false);
                            setNoticeperiod(parseInt(response.data.Result.employeeNoticePeriod.substring(0, 2)));
                        }
                        else {
                            setNoticeperiodNone(true);
                            setNoticeperiod(0);
                        }
                        setApplicantIDSalary(response.data.Result.userId);
                        setApplicantName(response.data.Result.formalName);
                        setApplicantPosition(response.data.Result.jobTitle);
                        setApplicantHireDate(response.data.Result.hireDate);
                        setApplicantPayGrade(response.data.Result.payGrade);
                        setApplicantWorkLocation(response.data.Result.actualWorkLocation);
                        setApplicantCompanyCode(response.data.Result.companyCode);
                        // setApplicantSaturdayCode(response.data.Result.workingSaturdayGroupCode);
                        // setApplicantSaturdayGroup(response.data.Result.workingSaturdayGroup);
                    }
                })
                .catch((err) => console.error(err));
        }
    }

    async function getResignApplicantDetailwithBadgeID() {
        if (applicantUserName) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/getResignApplicantDetail';
            axios
                .post(url, { badgeID: applicantID })
                .then((response) => {
                    if (response.data.status === 0) {
                        alert("There contain no data on this user. Please contact IT regarding this issue.")
                        history.push('/resignation');
                        window.location.reload();
                    }
                    else {
                        if (response.data.Result.employeeNoticePeriod.includes("MONTH") || response.data.Result.employeeNoticePeriod.includes("Month")) {
                            setNoticeperiod(parseInt(response.data.Result.employeeNoticePeriod.substring(0, 2)));
                        }
                        else if (response.data.Result.employeeNoticePeriod.includes("WEEK")|| response.data.Result.employeeNoticePeriod.includes("Week")) {
                            setNoticeperiodmonth(false);
                            setNoticeperiod(parseInt(response.data.Result.employeeNoticePeriod.substring(0, 2)));
                        }
                        else {
                            setNoticeperiodNone(true);
                            setNoticeperiod(0);
                        }
                        setApplicantIDSalary(response.data.Result.userId);
                        setApplicantName(response.data.Result.formalName);
                        setApplicantPosition(response.data.Result.jobTitle);
                        setApplicantHireDate(response.data.Result.hireDate);
                        setApplicantPayGrade(response.data.Result.payGrade);
                        setApplicantWorkLocation(response.data.Result.actualWorkLocation);
                        setApplicantCompanyCode(response.data.Result.companyCode);
                        // setApplicantSaturdayCode(response.data.Result.workingSaturdayGroupCode);
                        // setApplicantSaturdayGroup(response.data.Result.workingSaturdayGroup);
                    }
                })
                .catch((err) => console.error(err));
        }
    }

    useEffect(() => {
        if (applicantCompanyCode) {
            getPayrollCompanyDetail();
        }
    }, [applicantCompanyCode]);

    async function getPayrollCompanyDetail() {
        if (applicantCompanyCode) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/getPayrollCompDetail';
            axios
                .post(url, { code: applicantCompanyCode })
                .then((response) => {
                    setApplicantPayrollFactory(response.data.BankAccList[0].companyName);
                    setApplicantPayrollFactoryBank(response.data.BankAccList[0].bankName);
                    setApplicantPayrollFactoryAccNo(response.data.BankAccList[0].bankNo);
                })
                .catch((err) => console.error(err));
        }
    }

    useEffect(() => {
        if (applicantIDSalary) {
            getApplicantSalary();
        }
    }, [applicantIDSalary]);

    async function getApplicantSalary() {
        if (applicantIDSalary) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/getApplicantSalary';
            axios
                .post(url, { id: applicantIDSalary })
                .then((response) => {
                    var decrypt = new JSEncrypt();
                    decrypt.setPrivateKey(REACT_APP_PRIVATE_KEY_RESIGNATION);
                    var decrypted = decrypt.decrypt(response.data.paycompvalue);
                    setApplicantSalary(parseInt(decrypted));
                    setIsLoading(false);
                })
                .catch((err) => console.error(err));
        }
    }

    useEffect(() => {
        if (applicantWorkLocation) {
            fetchEmailList();
        }
    }, [applicantWorkLocation]);

    async function fetchEmailList() {
        if (applicantWorkLocation) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/fetchemail';
            axios
                .post(url, { factory: applicantWorkLocation })
                .then((response) => {
                    if (response.data.payrollEmailList?.length > 0) {
                        setPayrollEmail(response.data.payrollEmailList[0].email)
                    }
                    else {
                        setPayrollEmail("PayrollManagerGroupStaff@topglove.com.my")
                        // setPayrollEmail("zl_tan@topglove.com.my")
                    }
                })
                .catch((err) => console.error(err));
        }
    }

    useEffect(() => {
        if (applicantID) {
            fetchNotiToken();
        }
    }, [applicantID]);

    async function fetchNotiToken() {
        if (applicantID) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/grievance/getnotitoken';
            axios
                .post(url, { userID: applicantID })
                .then((response) => {
                    setNotiToken(response.data.UserDataList[0].token);
                })
                .catch((err) => console.error(err));
        }
    }

    //Calculate Length of Service = Current Date - Date Joined
    useEffect(() => {
        if (applicantHireDate && resignationDate) {
            const todayDate = moment(resignationDate);
            const diff = moment.duration(todayDate.diff(applicantHireDate)).add(1, 'days');
            if (diff.years() === 0) {
                setApplicantServiceLength(diff.months() + " months " + diff.days() + " days")
            }
            else if (diff.years() === 0 && diff.months() === 0) {
                setApplicantServiceLength(diff.days() + " days")
            }
            else {
                setApplicantServiceLength(diff.years() + " years " + diff.months() + " months " + diff.days() + " days")
            }
        }
    }, [applicantHireDate, resignationDate]);

    //Resignation with Notice = Resignation Date + Notice Period - 1 day
    useEffect(() => {
        if (noticePeriod?.length !== 0 && resignationDate) {
            const submittedDate = moment(resignationDate).format('DD/MM/YYYY');
            const endOfSubmittedMonth = moment(resignationDate).endOf('month').format('DD/MM/YYYY');
            const initialDayofMonth = moment(resignationDate).endOf('month').format('DD');
            const afterDayofMonth = moment(resignationDate).add(noticePeriod, 'month').endOf('month').format('DD');
            if (noticePeriodMonth) {
                if (moment(resignationDate).add(noticePeriod, 'month').format('DD/MM') == "28/02" && (moment(resignationDate).format('DD/MM') == "29/12" || moment(resignationDate).format('DD/MM') == "30/12" || moment(resignationDate).format('DD/MM') == "31/12")) {
                    setResignationdatewithnotice(moment(resignationDate).add(noticePeriod, 'month').format('DD/MM/YYYY'));
                    setResignationdatewithnoticeV2(moment(resignationDate).add(noticePeriod, 'month').format('YYYY-MM-DD'));
                }
                else if (submittedDate == endOfSubmittedMonth) {
                    if (initialDayofMonth > afterDayofMonth) {
                        setResignationdatewithnotice(moment(resignationDate).add(noticePeriod, 'month').format('DD/MM/YYYY'));
                        setResignationdatewithnoticeV2(moment(resignationDate).add(noticePeriod, 'month').format('YYYY-MM-DD'));
                    }
                    else {
                        setResignationdatewithnotice(moment(resignationDate).add(noticePeriod, 'month').subtract(1, 'days').format('DD/MM/YYYY'));
                        setResignationdatewithnoticeV2(moment(resignationDate).add(noticePeriod, 'month').subtract(1, 'days').format('YYYY-MM-DD'));
                    }
                }
                else {
                    setResignationdatewithnotice(moment(resignationDate).add(noticePeriod, 'month').subtract(1, 'days').format('DD/MM/YYYY'));
                    setResignationdatewithnoticeV2(moment(resignationDate).add(noticePeriod, 'month').subtract(1, 'days').format('YYYY-MM-DD'));
                }
            }
            else if (!noticePeriodMonth) {
                setResignationdatewithnotice(moment(resignationDate).add(noticePeriod, 'weeks').subtract(1, 'days').format('DD/MM/YYYY'));
                setResignationdatewithnoticeV2(moment(resignationDate).add(noticePeriod, 'weeks').subtract(1, 'days').format('YYYY-MM-DD'));
            }
            else if (noticePeriodNone) {
                setResignationdatewithnotice(moment(resignationDate).format('DD/MM/YYYY'));
                setResignationdatewithnoticeV2(moment(resignationDate).format('YYYY-MM-DD'));
            }
        }
    }, [noticePeriod, resignationDate]);

    //Short Notice = Resignation Date + Notice Period - Last Working Date
    useEffect(() => {
        //!====== hidden console.log()
        // console.log("lastWorkingDate = " + lastWorkingDate);
        // console.log("shortNoticeGiven = " + shortNoticeGiven);
        // console.log("noticePeriodNone = " + noticePeriodNone);
        if (resignationDatewithNoticeV2?.length !== 0) {
            if (shortNoticeGiven) {
                if (noticePeriodNone) {
                    setShortnotice(0);
                }
                else {
                    var startYear = parseInt(moment(lastWorkingDate).format('YYYY'));
                    var endYear = parseInt(resignationDatewithNoticeV2?.substring(0, 5));
                    if (startYear === endYear) {
                        var start = moment(resignationDatewithNoticeV2);
                        var end = moment(lastWorkingDate).format('YYYY-MM-DD');
                        setShortnotice(moment.duration(start.diff(end)).asDays());
                    }
                    else if (startYear !== endYear) {
                        var start = moment(resignationDatewithNoticeV2);
                        var end = moment(moment(lastWorkingDate).format('YYYY-MM-DD'));
                        setShortnotice(moment.duration(start.diff(end)).asDays());
                    }
                }
            }
        }
    }, [resignationDatewithNoticeV2, shortNoticeGiven, lastWorkingDate]);

    /*Old Last Physical Working Date = Requested Last Day by Employee, adjust to working calendar day, i.e. if weekend need to move to Friday (Working Saturday abolish)
    useEffect(() => {
        if(location.state.rowData.formStatusID == 1 || location.state.rowData.formStatusID == 2 || location.state.rowData.formStatusID == 5){
            if(lastWorkingDate){
                const Sunday = 0;
                const Saturday = 6;
                let tempDate;
                
                if(shortNoticeGiven){
                    tempDate = moment(lastWorkingDate);
                }
                else{
                    tempDate = moment(resignationDatewithNoticeV2);
                }
                while (tempDate.day() === Sunday || tempDate.day() === Saturday || tempDate.format("DD/MM/YYYY") === "01/02/2022" || tempDate.format("DD/MM/YYYY") === "02/02/2022" || tempDate.format("DD/MM/YYYY") === "02/05/2022" || 
                tempDate.format("DD/MM/YYYY") === "03/05/2022" || tempDate.format("DD/MM/YYYY") === "04/05/2022" || tempDate.format("DD/MM/YYYY") === "16/05/2022" || tempDate.format("DD/MM/YYYY") === "06/06/2022" || 
                tempDate.format("DD/MM/YYYY") === "11/07/2022" || tempDate.format("DD/MM/YYYY") === "31/08/2022" || tempDate.format("DD/MM/YYYY") === "16/09/2022" || tempDate.format("DD/MM/YYYY") === "10/10/2022" || 
                tempDate.format("DD/MM/YYYY") === "24/10/2022" || tempDate.format("DD/MM/YYYY") === "12/12/2022" || tempDate.format("DD/MM/YYYY") === "26/12/2022" || tempDate.format("DD/MM/YYYY") === "02/01/2023"){
                    tempDate.subtract(1,'days');
                }
                setLastPhysicalWorkingDate(moment(tempDate))
            }
        }
    }, [shortNoticeGiven, lastWorkingDate, resignationDatewithNoticeV2]);*/

    //!====== IMPORTANT NEEDS TO BE CHANGE YEARLY (OBSERVED PUBLIC HOLIDAYS exclude Birthday of State Ruler)
    //Last Physical Working Date = Requested Last Day by Employee, adjust to working calendar day, i.e. if weekend need to move to Friday or Working Saturday (Working Saturday not abolish)
    useEffect(() => {
        if (location.state.rowData.formStatusID == 1 || location.state.rowData.formStatusID == 2 || location.state.rowData.formStatusID == 5) {
            if (applicantSaturdayCode) {
                const Sunday = 0;
                const Saturday = 6;
                let tempDate;

                if (shortNoticeGiven) {
                    tempDate = moment(lastWorkingDate);
                }
                else if (!shortNoticeGiven && lastWorkingDate != '1/1/0001 12:00:00 AM') {
                    tempDate = moment(lastWorkingDate);
                }
                else {
                    tempDate = moment(resignationDatewithNoticeV2);
                }
                while (tempDate.day() === Sunday || tempDate.day() === Saturday ||
                    tempDate.format("DD/MM/YYYY") === "01/01/2025" || tempDate.format("DD/MM/YYYY") === "29/01/2025" || tempDate.format("DD/MM/YYYY") === "30/01/2025" || tempDate.format("DD/MM/YYYY") === "11/02/2025" ||
                    tempDate.format("DD/MM/YYYY") === "31/03/2025" || tempDate.format("DD/MM/YYYY") === "01/04/2025" || tempDate.format("DD/MM/YYYY") === "01/05/2025" ||
                    tempDate.format("DD/MM/YYYY") === "12/05/2025" || tempDate.format("DD/MM/YYYY") === "02/06/2025" || tempDate.format("DD/MM/YYYY") === "27/06/2025" ||
                    tempDate.format("DD/MM/YYYY") === "01/09/2025" || tempDate.format("DD/MM/YYYY") === "05/09/2025" || tempDate.format("DD/MM/YYYY") === "16/09/2025" ||
                    tempDate.format("DD/MM/YYYY") === "20/10/2025" || tempDate.format("DD/MM/YYYY") === "25/12/2025" || tempDate.format("DD/MM/YYYY") === "01/01/2026") {
                    if (tempDate.day() === Sunday) {
                        tempDate.subtract(1, 'days');
                    }
                    else if (tempDate.day() === Saturday) {
                        let weekSaturday = Math.ceil(tempDate.date() / 7);
                        //Saturday Public Holiday
                        if (tempDate.format("DD/MM/YYYY") == "07/06/2024") {
                            tempDate.subtract(1, 'days');
                        }
                        //Saturday Public Holiday
                        // else if (tempDate.format("DD/MM/YYYY") == "31/08/2024") {
                        //     tempDate.subtract(1, 'days');
                        // }
                        // 5th week of Working Saturday Group C 2024
                        else if (tempDate.format("DD/MM/YYYY") == "30/11/2024") {
                            if (applicantSaturdayCode == "0010" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        //5th week of Working Saturday Group D 2025
                        else if (tempDate.format("DD/MM/YYYY") == "29/03/2025") {
                            if (applicantSaturdayCode == "0001" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        //5th week of Working Saturday Group A 2025
                        else if (tempDate.format("DD/MM/YYYY") == "31/05/2025") {
                            if (applicantSaturdayCode == "1000" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }

                        //5th week of Working Saturday Group B 2025
                        else if (tempDate.format("DD/MM/YYYY") == "30/08/2025") {
                            if (applicantSaturdayCode == "0100" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        //5th week of Working Saturday Group C 2025
                        else if (tempDate.format("DD/MM/YYYY") == "29/11/2025") {
                            if (applicantSaturdayCode == "0010" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        else if (weekSaturday === 1) {
                            if (applicantSaturdayCode == "1000" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        else if (weekSaturday === 2) {
                            if (applicantSaturdayCode == "0100" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        else if (weekSaturday === 3) {
                            if (applicantSaturdayCode == "0010" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                        else if (weekSaturday === 4) {
                            if (applicantSaturdayCode == "0001" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222" || applicantSaturdayCode == "1111") {
                                break;
                            }
                            else {
                                tempDate.subtract(1, 'days');
                            }
                        }
                    }
                    //Non-Saturday Public Holiday
                    else if (
                    tempDate.format("DD/MM/YYYY") === "01/01/2025" || tempDate.format("DD/MM/YYYY") === "29/01/2025" || tempDate.format("DD/MM/YYYY") === "30/01/2025" || tempDate.format("DD/MM/YYYY") === "11/02/2025" ||
                    tempDate.format("DD/MM/YYYY") === "31/03/2025" || tempDate.format("DD/MM/YYYY") === "01/04/2025" || tempDate.format("DD/MM/YYYY") === "01/05/2025" ||
                    tempDate.format("DD/MM/YYYY") === "12/05/2025" || tempDate.format("DD/MM/YYYY") === "02/06/2025" || tempDate.format("DD/MM/YYYY") === "27/06/2025" ||
                    tempDate.format("DD/MM/YYYY") === "01/09/2025" || tempDate.format("DD/MM/YYYY") === "05/09/2025" || tempDate.format("DD/MM/YYYY") === "16/09/2025" ||
                    tempDate.format("DD/MM/YYYY") === "20/10/2025" || tempDate.format("DD/MM/YYYY") === "25/12/2025" || tempDate.format("DD/MM/YYYY") === "01/01/2026") {
                        tempDate.subtract(1, 'days');
                    }
                }
                if (tempDate.day() === Saturday) {
                    setLastPhysicalSaturday(true);
                }
                setLastPhysicalWorkingDate(moment(tempDate))
            }
        }
    }, [applicantSaturdayCode, shortNoticeGiven, lastWorkingDate, resignationDatewithNoticeV2]);

    /*Old Last Drawn Salary Date = Submission Date + Notice - Short Notice - 1 day + Leave (Leave should only be calculated based on working day so if weekend need to move forward to Monday etc) (Working Saturday abolish)
    useEffect(() => {
        if(location.state.rowData.formStatusID == 1 || location.state.rowData.formStatusID == 2 || location.state.rowData.formStatusID == 5){
            if(leaveDays?.length !== 0 && noticePeriod?.length !== 0){
                const Sunday = 0;
                const Saturday = 6;
                let tempDate;
                let remainingLeaves = leaveDays;
                
    
                if(noticePeriodMonth){
                    tempDate = moment(resignationDate).add(noticePeriod, 'month').subtract(shortNotice, 'days').subtract(1, 'days');
                }
                else if(!noticePeriodMonth){
                    tempDate = moment(resignationDate).add(noticePeriod, 'weeks').subtract(shortNotice, 'days').subtract(1, 'days');
                }
                else if(noticePeriodNone){
                    tempDate = moment(resignationDate);
                }
    
                while (remainingLeaves > 0){
                    tempDate.add(1,'days');
                    const tempDateV2 = moment(tempDate.clone()).format("DD/MM/YYYY");
                    if(tempDate.day() === Sunday){
                    }
                    else if (tempDate.day() === Saturday){
                    }
                    else if (tempDateV2 !== "18/01/2022" && tempDateV2 !== "01/02/2022" && tempDateV2 !== "02/02/2022" && tempDateV2 !== "02/05/2022" && tempDateV2 !== "03/05/2022" &&
                    tempDateV2 !== "04/05/2022" && tempDateV2 !== "16/05/2022" && tempDateV2 !== "06/06/2022" && tempDateV2 !== "11/07/2022" && tempDateV2 !== "31/08/2022" && 
                    tempDateV2 !== "16/09/2022" && tempDateV2 !== "10/10/2022" && tempDateV2 !== "24/10/2022" && tempDateV2 !== "12/12/2022" && tempDateV2 !== "26/12/2022" 
                    && tempDateV2 !== "02/01/2023"){
                        remainingLeaves--;
                    }
                }
                //check if after leave utilization will the last drawn date exceed notice period, set the last drawn date to the same date as resignation with notice
                if(moment.duration(tempDate.diff(resignationDatewithNoticeV2)).asDays() > 0){
                    setLastDrawnSalaryDate(moment(resignationDatewithNoticeV2));
                }
                else{
                    setLastDrawnSalaryDate(moment(tempDate))
                }
            }
        }
    }, [leaveDays, noticePeriod, shortNotice]);*/

    //!==== IMPORTANT NEEDS TO BE CHANGE YEARLY 
    //Last Drawn Salary Date = Submission Date + Notice - Short Notice - 1 day + Leave (Leave should only be calculated based on working day so if weekend need to move forward to Monday etc) (Working Saturday not abolish)
    useEffect(() => {
        if (location.state.rowData.formStatusID == 1 || location.state.rowData.formStatusID == 2 || location.state.rowData.formStatusID == 5) {
            if (leaveDays?.length !== 0 && noticePeriod?.length !== 0 && resignationDate) {
                const Sunday = 0;
                const Saturday = 6;
                let tempDate;
                let remainingLeaves = leaveDays;

                const submittedDate = moment(resignationDate).format('DD/MM/YYYY');
                const endOfSubmittedMonth = moment(resignationDate).endOf('month').format('DD/MM/YYYY');
                const initialDayofMonth = moment(resignationDate).endOf('month').format('DD');
                const afterDayofMonth = moment(resignationDate).add(noticePeriod, 'month').endOf('month').format('DD');
                if (noticePeriodMonth) {
                    if (submittedDate == endOfSubmittedMonth) {
                        if (initialDayofMonth > afterDayofMonth) {
                            tempDate = moment(resignationDate).add(noticePeriod, 'month').subtract(shortNotice, 'days');
                        }
                        else {
                            tempDate = moment(resignationDate).add(noticePeriod, 'month').subtract(shortNotice, 'days').subtract(1, 'days');
                        }
                    }
                    else {
                        tempDate = moment(resignationDate).add(noticePeriod, 'month').subtract(shortNotice, 'days').subtract(1, 'days');
                    }
                }
                else if (!noticePeriodMonth) {
                    tempDate = moment(resignationDate).add(noticePeriod, 'weeks').subtract(shortNotice, 'days').subtract(1, 'days');
                }
                else if (noticePeriodNone) {
                    tempDate = moment(resignationDate);
                }

                while (remainingLeaves > 0) {
                    tempDate.add(1, 'days');
                    const tempDateV2 = moment(tempDate.clone()).format("DD/MM/YYYY");
                    if (tempDate.day() === Sunday) {
                    }
                    else if (tempDate.day() === Saturday) {
                        let weekSaturday = Math.ceil(tempDate.date() / 7);
                        //Saturday Public Holiday
                        if (tempDateV2 == "07/06/2025") {
                        }
                        //Saturday Public Holiday
                        // else if (tempDateV2 == "16/09/2023") {
                        // }

                        //Working Saturday 5th week Group C 2024
                        else if (tempDateV2 == "30/11/2024") {
                            if (applicantSaturdayCode == "0010" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        //Working Saturday 5th week Group D 2025
                        else if (tempDateV2 == "29/03/2025") {
                            if (applicantSaturdayCode == "0001" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        //Working Saturday 5th week Group A 2025
                        else if (tempDateV2 == "31/05/2025") {
                            if (applicantSaturdayCode == "1000" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        //Working Saturday 5th week Group B 2025
                        else if (tempDateV2 == "30/08/2025") {
                            if (applicantSaturdayCode == "0100" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        //Working Saturday 5th week Group C 2025
                        else if (tempDateV2 == "29/11/2025") {
                            if (applicantSaturdayCode == "0010" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        else if (weekSaturday === 1) {
                            if (applicantSaturdayCode == "1000" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        else if (weekSaturday === 2) {
                            if (applicantSaturdayCode == "0100" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        else if (weekSaturday === 3) {
                            if (applicantSaturdayCode == "0010" || applicantSaturdayCode == "1010" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "2020" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                        else if (weekSaturday === 4) {
                            if (applicantSaturdayCode == "0001" || applicantSaturdayCode == "0101" || applicantSaturdayCode == "1111") {
                                remainingLeaves -= 0.5;
                            }
                            else if (applicantSaturdayCode == "0202" || applicantSaturdayCode == "2222") {
                                remainingLeaves--;
                            }
                        }
                    }
                    //Normal Public Holiday (exclude Saturday) (Sunday become Monday) (with Selangor state ruler birthday)
                    else if (tempDateV2 !== "31/10/2024" || tempDateV2 !== "25/12/2024" ||
                        tempDateV2 !== "01/01/2025" || tempDateV2 !== "29/01/2025" || tempDateV2 !== "30/01/2025" || tempDateV2 !== "11/02/2025" ||
                    tempDateV2 !== "31/03/2025" || tempDateV2 !== "01/04/2025" || tempDateV2 !== "01/05/2025" ||
                    tempDateV2 !== "12/05/2025" || tempDateV2 !== "02/06/2025" || tempDateV2 !== "27/06/2025" ||
                    tempDateV2 !== "01/09/2025" || tempDateV2 !== "05/09/2025" || tempDateV2 !== "16/09/2025" ||
                    tempDateV2 !== "20/10/2025" || tempDateV2 !== "11/12/2025" || tempDateV2 !== "25/12/2025" || tempDateV2 !== "01/01/2026") {
                        remainingLeaves--;
                    }
                }
                if (remainingLeaves == "0") {
                    setHalfDayLeave(false);
                }
                else if (!Number.isInteger(remainingLeaves)) {
                    setHalfDayLeave(true);
                }
                else {
                    setHalfDayLeave(false);
                }
                if (tempDate.day() === Saturday) {
                    setLastDrawnSalarySaturday(true);
                }
                else {
                    setLastDrawnSalarySaturday(false);
                }
                //check if after leave utilization will the last drawn date exceed notice period, set the last drawn date to the same date as resignation with notice
                if (moment.duration(tempDate.diff(resignationDatewithNoticeV2)).asDays() >= 1) {
                    setLastDrawnSalaryDate(moment(resignationDatewithNoticeV2));
                    setHalfDayLeave(false);
                }
                else {
                    setLastDrawnSalaryDate(moment(tempDate));
                }
            }
        }
    }, [leaveDays, noticePeriod, shortNotice, applicantSaturdayCode, resignationDate, resignationDatewithNoticeV2]);

    /*True Short Notice = Resignation Date + Notice Period - Last Drawn Salary Date (Working Saturday abolish)
    useEffect(() => {
        if(resignationDatewithNoticeV2?.length !== 0){
            if(shortNoticeGiven){
                if(noticePeriodNone){
                    setShortnotice(0);
                }
                else{
                    var startYear = parseInt(moment(lastDrawnSalaryDate).format('YYYY'));
                    var endYear = parseInt(resignationDatewithNoticeV2?.substring(0, 5));
                    if(startYear === endYear){
                        var start = moment(resignationDatewithNoticeV2);
                        var end = moment(lastDrawnSalaryDate).format('YYYY-MM-DD');
                        setShortnoticeTrue(moment.duration(start.diff(end)).asDays());
                    }
                    else if(startYear !== endYear){
                        var start = moment(resignationDatewithNoticeV2);
                        var end = moment(moment(lastDrawnSalaryDate).format('YYYY-MM-DD'));
                        setShortnoticeTrue(moment.duration(start.diff(end)).asDays());
                    }
                }
            }
        }
    }, [resignationDatewithNoticeV2, shortNoticeGiven, lastDrawnSalaryDate]);*/

    // Old True Short Notice = Resignation Date + Notice Period - Last Drawn Salary Date (Working Saturday not abolish)
    useEffect(() => {
        if (resignationDatewithNoticeV2?.length !== 0) {
            if (shortNoticeGiven) {
                if (noticePeriodNone) {
                    setShortnotice(0);
                }
                else {
                    var startYear = parseInt(moment(lastDrawnSalaryDate).format('YYYY'));
                    var endYear = parseInt(resignationDatewithNoticeV2?.substring(0, 5));
                    if (startYear === endYear) {
                        var start = moment(resignationDatewithNoticeV2);
                        var end = moment(lastDrawnSalaryDate).format('YYYY-MM-DD');
                        if (halfDayLeave) {
                            setShortnoticeTrue(parseInt(moment.duration(start.diff(end)).asDays()) + 0.5);
                        }
                        else {
                            setShortnoticeTrue(moment.duration(start.diff(end)).asDays());
                        }
                    }
                    else if (startYear !== endYear) {
                        var start = moment(resignationDatewithNoticeV2);
                        var end = moment(moment(lastDrawnSalaryDate).format('YYYY-MM-DD'));
                        if (halfDayLeave) {
                            setShortnoticeTrue(parseInt(moment.duration(start.diff(end)).asDays()) + 0.5);
                        }
                        else {
                            setShortnoticeTrue(moment.duration(start.diff(end)).asDays());
                        }
                    }
                }
            }
        }
    }, [resignationDatewithNoticeV2, shortNoticeGiven, lastDrawnSalaryDate]);

    //Number of months between last working date and resignation date
    useEffect(() => {
        //!====== hidden console.log()
        // console.log("resignationDatewithNoticeV2 = " + resignationDatewithNoticeV2);
        // console.log("lastDrawnSalaryDate = " + lastDrawnSalaryDate);
        // console.log("resignationDate = " + resignationDate);
        if (resignationDatewithNoticeV2) {
            var startYear = parseInt(moment(lastDrawnSalaryDate).format('YYYY'));
            var endYear = parseInt(resignationDatewithNoticeV2?.substring(0, 5));
            if (startYear === endYear) {
                if (moment(resignationDate).format('DD/MM/YYYY') == moment(resignationDate).endOf('month').format('DD/MM/YYYY') && moment(lastDrawnSalaryDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).startOf('month').format('DD/MM/YYYY')) {
                    var startMonth = parseInt(moment(lastDrawnSalaryDate).format('M'));
                    var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                    setMonthDuration(endMonth - startMonth + 1);
                }
                // else if(moment(resignationDate).format('DD/MM/YYYY') == moment(resignationDate).endOf('month').format('DD/MM/YYYY') && moment(lastWorkingDate).format('DD/MM/YYYY') == moment(lastWorkingDate).endOf('month').format('DD/MM/YYYY')){
                //     var startMonth = parseInt(moment(lastWorkingDate).format('M'));
                //     var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                //     setMonthDuration(endMonth-startMonth);
                // }
                // else if(moment(resignationDate).format('DD/MM/YYYY') == moment(resignationDate).startOf('month').format('DD/MM/YYYY') && moment(lastWorkingDate).format('DD/MM/YYYY') == moment(lastWorkingDate).endOf('month').format('DD/MM/YYYY')){
                //     var startMonth = parseInt(moment(lastWorkingDate).format('M'));
                //     var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                //     setMonthDuration(endMonth-startMonth);
                // }
                else if (moment(lastDrawnSalaryDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).endOf('month').format('DD/MM/YYYY')) {
                    var startMonth = parseInt(moment(lastDrawnSalaryDate).format('M'));
                    var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                    setMonthDuration(endMonth - startMonth);
                }
                else {
                    var startMonth = parseInt(moment(lastDrawnSalaryDate).format('M'));
                    var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                    setMonthDuration(endMonth - startMonth + 1);
                }
            }
            else if (startYear !== endYear) {
                if (moment(resignationDate).format('DD/MM/YYYY') == moment(resignationDate).endOf('month').format('DD/MM/YYYY') && moment(lastDrawnSalaryDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).startOf('month').format('DD/MM/YYYY')) {
                    var startMonth = parseInt(moment(lastDrawnSalaryDate).format('M'));
                    var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                    setMonthDuration(endMonth - startMonth + 13);
                }
                else if (moment(lastDrawnSalaryDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).endOf('month').format('DD/MM/YYYY')) {
                    var startMonth = parseInt(moment(lastDrawnSalaryDate).format('M'));
                    var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                    setMonthDuration(endMonth - startMonth + 12);
                }
                else {
                    var startMonth = parseInt(moment(lastDrawnSalaryDate).format('M'));
                    var endMonth = parseInt(resignationDatewithNoticeV2?.substring(5, 7));
                    setMonthDuration(endMonth - startMonth + 13);
                }
            }
        }
    }, [resignationDatewithNoticeV2, lastDrawnSalaryDate]);

    //Setting values for minitable month, basic salary, days in month
    useEffect(() => {
        if (monthDuration?.length !== 0) {
            const monthlist = [];
            const monthdaylist = [];
            const basicSalarylist = [];
            for (let i = 0; i < monthDuration; i++) {
                // if(moment(resignationDate).format('DD/MM/YYYY') == moment(resignationDate).startOf('month').format('DD/MM/YYYY') && moment(lastWorkingDate).format('DD/MM/YYYY') == moment(lastWorkingDate).endOf('month').format('DD/MM/YYYY')){
                //     let currentmonth = moment(lastWorkingDate).add(i+1, 'month').format('MMM YYYY');
                //     let monthday = moment(currentmonth).daysInMonth()
                //     monthlist.push(currentmonth);
                //     monthdaylist.push(monthday);
                //     basicSalarylist.push(applicantSalary)
                // }
                //Start of the month for last day and resignation date is end of month. Example(31/03 resign, 01/04 last date)
                if (moment(resignationDate).format('DD/MM/YYYY') == moment(resignationDate).endOf('month').format('DD/MM/YYYY') && moment(lastDrawnSalaryDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).startOf('month').format('DD/MM/YYYY')) {
                    let currentmonth = moment(lastWorkingDate).add(i, 'month').format('MMM YYYY');
                    let monthday = moment(currentmonth).daysInMonth()
                    monthlist.push(currentmonth);
                    monthdaylist.push(monthday);
                    basicSalarylist.push(applicantSalary)
                }
                //Last day and resign same day which is end of the month. Example(31/03 resign, 31/03 last date)
                else if (moment(lastWorkingDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).endOf('month').format('DD/MM/YYYY')) {
                    let currentmonth = moment(lastWorkingDate).add(i + 1, 'month').format('MMM YYYY');
                    let monthday = moment(currentmonth).daysInMonth()
                    monthlist.push(currentmonth);
                    monthdaylist.push(monthday);
                    basicSalarylist.push(applicantSalary)
                }
                //Last drawn salary date is the last day of the month. Example(31/03 last drawn salary)
                else if (moment(lastDrawnSalaryDate).format('DD/MM/YYYY') == moment(lastDrawnSalaryDate).endOf('month').format('DD/MM/YYYY')) {
                    //only checking for february because got some issue not added plus 1 month
                    var currentYear = moment(lastDrawnSalaryDate).year();
                    var getLastDayOfFeb = new Date(currentYear, 2, 0)//get calendar last month
                    var bool = moment(lastDrawnSalaryDate).isAfter(currentYear + '-02-' + getLastDayOfFeb.getDay());

                    if (bool == true) {
                        let currentmonth = moment(lastWorkingDate).add(i + 1, 'month').format('MMM YYYY');
                        let monthday = moment(currentmonth).daysInMonth()
                        monthlist.push(currentmonth);
                        monthdaylist.push(monthday);
                        basicSalarylist.push(applicantSalary)
                    } else {
                        let currentmonth = moment(lastWorkingDate).add(i, 'month').format('MMM YYYY');
                        let monthday = moment(currentmonth).daysInMonth()
                        monthlist.push(currentmonth);
                        monthdaylist.push(monthday);
                        basicSalarylist.push(applicantSalary)

                    }


                }
                else {
                    let currentmonth = moment(lastDrawnSalaryDate).add(i, 'month').format('MMM YYYY');
                    let monthday = moment(currentmonth).daysInMonth()
                    monthlist.push(currentmonth);
                    monthdaylist.push(monthday);
                    basicSalarylist.push(applicantSalary)
                }
            }
            setMonthArray(monthlist);
            setMonthDayArray(monthdaylist);
            if (location.state.rowData.formStatusID == 1 || location.state.rowData.formStatusID == 2 || location.state.rowData.formStatusID == 5) {
                setbasicSalaryArray(basicSalarylist);
            }
        }
    }, [monthDuration, applicantSalary]);

    //Calculation for short days
    useEffect(() => {
        //!====== hidden console.log()
        // console.log("Calculation for Short Days");
        // console.log("monthArray = " + monthArray);
        // console.log("monthdayArray = " + monthdayArray);
        // console.log("shortNoticeTrue = " + shortNoticeTrue);

        if (monthArray?.length !== 0 && monthdayArray?.length !== 0) {
            const shortDaylist = [];
            let shortDay = shortNoticeTrue;
            if (monthArray?.length > 1) {
                for (let i = 0; i < monthArray?.length; i++) {
                    if (i == 0) {
                        var start = moment(moment(resignationDatewithNoticeV2).format('MMM YYYY'));
                        var end = moment(resignationDatewithNoticeV2);
                        var duration = moment.duration(end.diff(start)).asDays() + 1;
                        shortDaylist.push(duration);
                        shortDay = shortDay - duration;
                    }
                    else if (i !== monthArray?.length - 1) {
                        shortDaylist.push(monthdayArray[monthArray?.length - 1 - i]);
                        shortDay = shortDay - monthdayArray[monthArray?.length - 1 - i];
                    }
                    else if (i === monthArray?.length - 1) {
                        shortDaylist.push(shortDay);
                    }
                }
            }
            else {
                shortDaylist.push(shortDay);
            }
            shortDaylist.reverse();
            setShortdayArray(shortDaylist);
        }
    }, [monthArray, monthdayArray, shortNoticeTrue]);

    //Calculation for amount owe to company
    useEffect(() => {

        console.log("Calculation for amount owe to company");
        if (shortdayArray?.length !== 0 && basicSalaryArray?.length !== 0) {
            if (shortNoticeGiven) {
                const deductionList = [];
                let grandtotal = 0
                for (let i = 0; i < shortdayArray?.length; i++) {
                    let amountOwe = basicSalaryArray[i] / monthdayArray[i] * shortdayArray[i];
                    deductionList.push(amountOwe.toFixed(2));
                }
                for (let i = 0; i < deductionList?.length; i++) {
                    grandtotal = grandtotal + parseFloat(deductionList[i]);
                }
                console.log("Amount Owe to Company Calculation Result: ");
                console.log(deductionList);
                setDeductionSalaryArray(deductionList);
                setDeductionTotal(grandtotal.toFixed(2));

                console.log("deductionSalaryArray = " + deductionSalaryArray);
                console.log("deductionTotal = " + deductionTotal);
            }
            else {
                console.log("deductionTotal = " + 0);
                setDeductionTotal(0);
            }
        }
    }, [shortdayArray, basicSalaryArray]);

    // Row of Amount Owe to Company Table
    useEffect(() => {
        //!====== hidden console.log()
        // console.log("Row of table Amount Owe to Company");
        if (shortNoticeTrue != 0) {
            if (monthArray?.length !== 0 && monthdayArray?.length !== 0 && basicSalaryArray?.length !== 0 && shortdayArray?.length !== 0 && deductionSalaryArray?.length !== 0) {
                const completedata = [];
                for (let i = 0; i < deductionSalaryArray?.length; i++) {
                    let paymentlieudata = { month: monthArray[i], month_day: monthdayArray[i], basic_salary: basicSalaryArray[i], short_day: shortdayArray[i], total: deductionSalaryArray[i] };
                    completedata.push(paymentlieudata);
                }
                //!====== hidden console.log()
                // console.log(completedata);
                setTableInfoList(completedata);
            }

        } else {
            setTableInfoList(null);
        }

    }, [shortNoticeTrue, monthArray, monthdayArray, basicSalaryArray, shortdayArray, deductionSalaryArray]);

    //Styling of counter select dropdown
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#504c4c',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '6px 0px 4px 2px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    function downloadBlob(blob, filename) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'download';
        const clickHandler = () => {
            setTimeout(() => {
                URL.revokeObjectURL(url);
                a.removeEventListener('click', clickHandler);
            }, 150);
        };
        a.addEventListener('click', clickHandler, false);
        a.click();
        return a;
    }

    async function downloadFile() {
        if (resignationAttachment) {
            const fileUrl = await Storage.get(resignationAttachment, { download: true })
            if (resignationAttachment.includes("pdf")) {
                downloadBlob(fileUrl.Body, applicantName + '_Resignation Letter.pdf');
            }
            else if (resignationAttachment.includes("PDF")) {
                downloadBlob(fileUrl.Body, applicantName + '_Resignation Letter.PDF');
            }
        }
    }
    const startEdit = () => {
        if (!editStatus) {
            setEditStatus(true);
        }
        else {
            setEditStatus(false);
            window.location.reload();
        }
    }

    const handleChangeCounter = (selectedCounterOption) => {
        setSelectedOption(selectedCounterOption);
        if (selectedCounterOption) {
            setCounter(selectedCounterOption.value);
            if (selectedCounterOption.value == 0) {
                setCountervalue("");
                setCounterRemark("");
                setCounterRemarkStatus(false);
            }
        }
        else {
            setCounter("");
            setCountervalue("");
            setCounterRemark("");
            setCounterRemarkStatus(false);
        }
    };

    const handleShortNoticeUpdate = (newShortNotice) => {
        setNewShortNoticeDisplay(newShortNotice);

        setShortnoticegiven(newShortNotice.value);

        if (newShortNotice.value == 1 || newShortNotice.value == 2) {  // Yes and 24 hrs resignation

            setLeaveUtilisedEditable(true);
            setOpenShortNoticePayment(true);
        }
        else if (newShortNotice.value == 0) { // No 
            setLeaveUtilisedEditable(false);
            setShortNoticePaymentID(0);
            setLeavedays(0);
            setOpenShortNoticePayment(false);

        }
    };

    const handleShortNoticePaymentUpdate = (newShortNoticePayment) => {
        setShortNoticePaymentID(newShortNoticePayment.value);
        setShortNoticePaymentName(newShortNoticePayment.label);

    }

    const handleUpdateLeaveDays = (e) => {
        if (e.target.value != null || e.target.value != 0) {
            setLeavedays(e.target.value);
        } else {

            setShortNoticePaymentID(0);
            setLeavedays(0);
        }

    };

    const handleChangeWaive = (selectedCounterOption) => {

        setSelectedWaive(selectedCounterOption);
        if (selectedCounterOption) {
            setNoticeWaive(selectedCounterOption.value);
            if (selectedCounterOption.value == 1) {
                setNoticeWaiveRemarkStatus(true);
            }
            else {
                setNoticeWaiveRemark("");
                setNoticeWaiveRemarkStatus(false);
            }
        }
        else {
            setNoticeWaive("");
            setNoticeWaiveRemark("");
            setNoticeWaiveRemarkStatus(false);
        }
    };

    const updateCounterValue = (e) => {
        setCountervalue(e.target.value);
        setCounterRemarkStatus(true);
    };

    const updateLastWorkDateEmp = (date) => {
        setLastworkingdate(date);
        setLastWorkDateEmpStatus(true);
    };

    const updateLastDrawnSalary = (date) => {
        setLastDrawnSalaryDate(date);
        setEditLastSalaryRemarkStatus(true);
        setHalfDayLeave(false);
    };

    const updateLastWorkingDate = (date) => {
        setLastPhysicalWorkingDate(date);
        setEditLastWorkingDayStatus(true);
    };

    const updateSubmissionDate = (date) => {
        setResignationdate(date);
        setEditFinalCreatedDateStatus(true);
    };

    const updateBasicSalary = (index) => (e) => {
        let newSalaryArray = [...basicSalaryArray];
        let floatSalaryArray = [...basicSalaryArray];
        newSalaryArray[index] = e.target.value;
        floatSalaryArray[index] = newSalaryArray[index]
        setbasicSalaryArray(floatSalaryArray);
        setEditBasicSalaryRemarkStatus(true);
    };

    const approvalPDF = async () => {
        if (counter == "") {
            alert('Please select whether to counter the offer');
        }
        else if (counter == 1 && counterValue == "") {
            alert('Please input how much do you want to counter');
        }
        else if (noticeWaive == "") {
            alert('Please select whether to waive the payment');
        }
        else if (noticeWaiveRemarkStatus && noticeWaiveRemark == "") {
            alert('Please provide a remark on the reason for waiving the payment');
        }
        else if (resignationDate == "") {
            alert('Please input the last drawn salary date');
        }
        else if (editFinalCreatedDateStatus && editFinalCreatedDateRemark == "") {
            alert('Please provide a remark on the changes made to the resignation date');
        }
        else if (lastDrawnSalaryDate == "") {
            alert('Please input the last drawn salary date');
        }
        else if (editLastSalaryRemarkStatus && editLastSalaryRemark == "") {
            alert('Please provide a remark on the changes made to the last drawn salary date');
        }
        else if (shortNoticeGiven && lastWorkingDate == "") {
            alert('Please input the last working date by employee');
        }
        else if (lastWorkDateEmpStatus && lastWorkDateEmp == "") {
            alert('Please provide a remark on the changes made to the requested last day by the employee');
        }
        else if (editLastWorkingDayStatus && editLastWorkingDayRemark == "") {
            alert('Please provide a remark on the changes made to the last physical working date of the employee');
        }
        else if (editBasicSalaryRemarkStatus && editBasicSalaryRemark == "") {
            alert('Please provide a remark on the changes made to the basic salary of the employee');
        }
        else if ((shortNoticeGiven == 1 || shortNoticeGiven == 2) && shortNoticePaymentID == "0") {
            alert('Please select a short notice payment method.');
        }
        else {
            for (let i = 0; i < basicSalaryArray?.length; i++) {
                if (isNaN(basicSalaryArray[i]) || basicSalaryArray[i] == "") {
                    alert('Please ensure edited basic salary is a number and is not left empty');
                    return;
                }
            }
            if (!window.confirm('Do you want to approve this resignation form?')) {
                return false;
            }
            setIsLoading(true);
            const input = document.getElementById('divToPrint');
            html2canvas(input)
                .then((canvas) => {
                    const pdf = new jsPDF('l', 'mm', 'a4');
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const pageRatio = pageWidth / pageHeight;

                    let img = new Image();
                    const imgData = canvas.toDataURL('image/png');
                    img.src = imgData;
                    img.onload = function () {
                        const imgWidth = this.width;
                        const imgHeight = this.height;
                        const imgRatio = imgWidth / imgHeight;
                        if (imgRatio >= 1) {
                            const wc = imgWidth / pageWidth;
                            const pi = pageRatio / imgRatio;
                            if (imgRatio >= pageRatio) {
                                pdf.addImage(img, 'PNG', 0, (pageHeight - imgHeight / wc) / 2, pageWidth, imgHeight / wc, null, 'FAST');
                                setPDFforApprove(pdf.output('dataurlstring'));
                                // pdf.save("Offboarding Details.pdf");
                            }
                            else {
                                pdf.addImage(img, 'PNG', (pageWidth - pageWidth / pi) / 2, 0, pageWidth / pi, (imgHeight / pi) / wc, null, 'FAST');
                                setPDFforApprove(pdf.output('dataurlstring'));
                                // pdf.save("Offboarding Details.pdf");
                            }
                        }
                        else {
                            const wc = imgWidth / pageHeight;
                            const newpdf = new jsPDF('p', 'mm', 'a4');
                            if (1 / imgRatio > pageRatio) {
                                const ip = (1 / imgRatio) / pageRatio;
                                // const margin = (pageHeight - ((imgHeight / ip) / wc)) / 4;
                                newpdf.addImage(img, 'PNG', 0, 0, pageHeight / ip, (imgHeight / ip) / wc, null, 'FAST');
                                setPDFforApprove(newpdf.output('dataurlstring'));
                                // newpdf.save("Offboarding Details.pdf");
                            }
                            else {
                                newpdf.addImage(img, 'PNG', 0, (pageWidth - imgHeight / wc) / 2, pageHeight, imgHeight / wc, null, 'FAST');
                                setPDFforApprove(newpdf.output('dataurlstring'));
                                // newpdf.save("Offboarding Details.pdf");
                            }
                        }
                    }
                });
        }
    }

    const sendPayrollEmail = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/sendpayrollemail';
        const emailInfo = {
            email_receiver: email.payrollEmail,
            email_cc: email.payrollEmail,
            requester_name: email.applicantName,
            requester_id: email.applicantID,
            requester_factory: email.applicantWorkLocation,
            payment_type: email.shortNoticePaymentName,
            attachment: email.pdfForApprove,
        };
        axios
            .post(url, emailInfo)
            .then(
                sendSuperiorEmail({
                    superiorEmail,
                    superiorName,
                    applicantName,
                    applicantWorkLocation,
                    lastDrawnSalaryDate,
                    lastPhysicalWorkingDate,
                })
            )
            .catch((err) => console.error(err));
    };

    const sendPayrollEmail_verNoShort = async (email) => {
        let lastDrawnSalaryDate = resignationDatewithNoticeV2;
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/sendpayrollemail_noshort';
        const emailInfo = {
            email_receiver: email.payrollEmail,
            email_cc: email.payrollEmail,
            requester_name: email.applicantName,
            requester_id: email.applicantID,
            requester_factory: email.applicantWorkLocation,
            attachment: email.pdfForApprove,
        };
        axios
            .post(url, emailInfo)
            .then(
                sendSuperiorEmail({
                    superiorEmail,
                    superiorName,
                    applicantName,
                    applicantWorkLocation,
                    lastDrawnSalaryDate,
                    lastPhysicalWorkingDate,
                })
            )
            .catch((err) => console.error(err));
    };

    const sendApplicantEmail_verDeduction = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/sendApplicantApprovalDeduction';
        const emailInfo = {
            email_receiver: email.applicantEmail,
            email_cc: email.applicantEmail,
            requester_name: email.applicantName,
            requester_factory: email.applicantWorkLocation,
            payment_type: email.shortNoticePaymentName,
            attachment: email.pdfForApprove,
        };
        axios
            .post(url, emailInfo)
            .then((response) => {
                alert('Resignation has been approved!');
                history.push('/resignation');
                window.location.reload();
            })
            .catch((err) => console.error(err));
    };

    const sendApplicantEmail_verTransfer = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/sendApplicantApprovalTransfer';
        const emailInfo = {
            email_receiver: email.applicantEmail,
            email_cc: email.applicantEmail,
            requester_name: email.applicantName,
            requester_factory: email.applicantWorkLocation,
            payment_type: email.shortNoticePaymentName,
            company_full_name: email.applicantPayrollFactory,
            company_bank: email.applicantPayrollFactoryBank,
            company_account_no: email.applicantPayrollFactoryAccNo,
            attachment: email.pdfForApprove,
        };
        axios
            .post(url, emailInfo)
            .then((response) => {
                alert('Resignation has been approved! ');
                history.push('/resignation');
                window.location.reload();
            })
            .catch((err) => console.error(err));
    };

    const sendApplicantEmail_verNoShort = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/sendApplicantApprovalNoShort';
        const emailInfo = {
            email_receiver: email.applicantEmail,
            email_cc: email.applicantEmail,
            requester_name: email.applicantName,
            requester_factory: email.applicantWorkLocation,
            attachment: email.pdfForApprove,
        };
        axios
            .post(url, emailInfo)
            .then((response) => {
                alert('Resignation has been approved!');
                history.push('/resignation');
                window.location.reload();
            })
            .catch((err) => console.error(err));
    };

    const sendSuperiorEmail = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/sendSuperiorApproval'; 
        const emailInfo = { 
            email_receiver: email.superiorEmail,  
            email_cc: email.superiorEmail,
            superior_name: email.superiorName, 
            requester_name: email.applicantName,
            requester_factory: email.applicantWorkLocation,
            last_drawn_salary: moment(email.lastDrawnSalaryDate).format('DD/MM/YYYY'),
            last_physical_date: moment(email.lastPhysicalWorkingDate).format('DD/MM/YYYY'),
        };
        axios
            .post(url, emailInfo)
            .then((response) => {
                if (shortNoticeGiven) {
                    if (shortNoticePaymentID == 2) {
                        sendApplicantEmail_verDeduction({
                            applicantEmail,
                            applicantName,
                            applicantWorkLocation,
                            shortNoticePaymentName,
                            pdfForApprove,
                        })
                    }
                    else {
                        sendApplicantEmail_verTransfer({
                            applicantEmail,
                            applicantName,
                            applicantWorkLocation,
                            shortNoticePaymentName,
                            applicantPayrollFactory,
                            applicantPayrollFactoryBank,
                            applicantPayrollFactoryAccNo,
                            pdfForApprove,
                        })
                    }
                }
                else {
                    sendApplicantEmail_verNoShort({
                        applicantEmail,
                        applicantName,
                        applicantWorkLocation,
                        pdfForApprove,
                    })
                }
            })
            .catch((err) => console.error(err));
    };

    const approveResign = async () => {
        const monthlist = monthArray.toString();
        const salarylist = basicSalaryArray.toString();
        let finalworkingdate = "";
        let finalDrawnSalaryDate = "";
        if (shortNoticeGiven) {
            finalworkingdate = moment(lastWorkingDate).format('YYYY-MM-DD');
            finalDrawnSalaryDate = moment(lastDrawnSalaryDate).format('YYYY-MM-DD');
        }
        else if (!shortNoticeGiven && lastWorkingDate != '1/1/0001 12:00:00 AM') {
            finalworkingdate = moment(lastWorkingDate).format('YYYY-MM-DD');
            if (editLastSalaryRemark.toString() !== "") {
                finalDrawnSalaryDate = moment(lastDrawnSalaryDate).format('YYYY-MM-DD');
            }
            else {
                finalDrawnSalaryDate = moment(resignationDatewithNoticeV2).format('YYYY-MM-DD');
            }
        }
        else {
            finalworkingdate = moment(lastPhysicalWorkingDate).format('YYYY-MM-DD');
            if (editLastSalaryRemark.toString() !== "") {
                finalDrawnSalaryDate = moment(lastDrawnSalaryDate).format('YYYY-MM-DD');
            }
            else {
                finalDrawnSalaryDate = moment(resignationDatewithNoticeV2).format('YYYY-MM-DD');
            }
        }
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/resignapprove';
        const resignationApprovaldetails = {
            shortNotice: shortNoticeGiven,
            shortNoticePayment: shortNoticePaymentID,
            leaveUtilize: leaveDays == 0 ? 0 : 1,
            leaveUtilizeDay: leaveDays,
            updatedBy: currentUserID,
            formID: formID,
            formStatus: 3,
            counterStatus: counter,
            counterValue: counterValue,
            counterRemark: counterRemark.toString(),
            lastSalaryDate: finalDrawnSalaryDate,
            lastSalaryDateRemark: editLastSalaryRemark.toString(),
            lastWorkDate: moment(resignationDatewithNoticeV2).format('YYYY-MM-DD'),
            lastWorkDateEmployee: finalworkingdate,
            lastWorkDateRemark: lastWorkDateEmp.toString(),
            basicSalary: salarylist,
            basicSalaryRemark: editBasicSalaryRemark.toString(),
            month: monthlist,
            shortDay: shortNoticeTrue.toString(),
            lastPhysicalDate: moment(lastPhysicalWorkingDate).format('YYYY-MM-DD'),
            lastPhysicalDateRemark: editLastWorkingDayRemark.toString(),
            noticeWaiveStatus: noticeWaive,
            noticeWaiveRemark: noticeWaiveRemark.toString(),
            finalCreatedDate: moment(resignationDate).format('YYYY-MM-DD'),
            finalCreatedDateRemark: editFinalCreatedDateRemark.toString(),
        };
        axios
            .post(url, resignationApprovaldetails)
            .then((response) => {
                if (response.data.name == "Error") {
                    alert('An error has occured while approving this form please try again.');
                    setTimeout(() => {
                        history.push('/resignation');
                        window.location.reload();
                    }, 1000)
                }
                else {
                    if (shortNoticeGiven) {
                        sendPayrollEmail({
                            payrollEmail,
                            applicantName,
                            applicantWorkLocation,
                            shortNoticePaymentName,
                            pdfForApprove
                        })
                    }
                    else {
                        sendPayrollEmail_verNoShort({
                            payrollEmail,
                            applicantName,
                            applicantWorkLocation,
                            pdfForApprove
                        })
                    }
                }
            })
            .catch((err) => console.error(err));
    };

    //When click apporve, it will convert the page to pdf first through approvalPDF(), once the it is complete it will run approveResign() automatically.
    useEffect(() => {
        if (pdfForApprove?.length !== 0) {
            approveResign();
        }
    }, [pdfForApprove]);

    const counterResign = async () => {
        if (counter == "") {
            alert('Please select whether to counter the offer');
        }
        else if (counter == 1 && counterValue == "") {
            alert('Please input how much do you want to counter');
        }
        else if (noticeWaive == "") {
            alert('Please select whether to waive the payment');
        }
        else if (noticeWaiveRemarkStatus && noticeWaiveRemark == "") {
            alert('Please provide a remark on the reason for waiving the payment');
        }
        else if (lastDrawnSalaryDate == "") {
            alert('Please input the last drawn salary date');
        }
        else if (editLastSalaryRemarkStatus && editLastSalaryRemark == "") {
            alert('Please provide a remark on the changes made to the last drawn salary date');
        }
        else if (shortNoticeGiven && lastWorkingDate == "") {
            alert('Please input the last working date by employee');
        }
        else if (lastWorkDateEmpStatus && lastWorkDateEmp == "") {
            alert('Please provide a remark on the changes made to the requested last day by the employee');
        }
        else if (editLastWorkingDayStatus && editLastWorkingDayRemark == "") {
            alert('Please provide a remark on the changes made to the last physical working date of the employee');
        }
        else if (editBasicSalaryRemarkStatus && editBasicSalaryRemark == "") {
            alert('Please provide a remark on the changes made to the basic salary of the employee');
        }
        else {
            for (let i = 0; i < basicSalaryArray?.length; i++) {
                if (isNaN(basicSalaryArray[i]) || basicSalaryArray[i] == "") {
                    alert('Please ensure edited basic salary is a number and is not left empty');
                    return;
                }
            }
            if (!window.confirm('Do you want to counter this resignation form?')) {
                return false;
            }
            const monthlist = monthArray.toString();
            const salarylist = basicSalaryArray.toString();
            let finalworkingdate = "";
            if (lastWorkingDate) {
                finalworkingdate = moment(lastWorkingDate).format('YYYY-MM-DD');
            }
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/resignapprove';
            const resignationApprovaldetails = {
                shortNotice: shortNoticeGiven,
                shortNoticePayment: shortNoticePaymentID,
                leaveUtilize: leaveDays == 0 ? 0 : 1,
                leaveUtilizeDay: leaveDays,
                updatedBy: currentUserID,
                formID: formID,
                formStatus: 4,
                counterStatus: counter,
                counterValue: counterValue,
                counterRemark: counterRemark.toString(),
                lastSalaryDate: moment(lastDrawnSalaryDate).format('YYYY-MM-DD'),
                lastSalaryDateRemark: editLastSalaryRemark.toString(),
                lastWorkDate: moment(resignationDatewithNoticeV2).format('YYYY-MM-DD'),
                lastWorkDateEmployee: finalworkingdate,
                lastWorkDateRemark: lastWorkDateEmp.toString(),
                basicSalary: salarylist,
                basicSalaryRemark: editBasicSalaryRemark.toString(),
                month: monthlist,
                shortDay: shortNoticeTrue.toString(),
                lastPhysicalDate: moment(lastPhysicalWorkingDate).format('YYYY-MM-DD'),
                lastPhysicalDateRemark: editLastWorkingDayRemark.toString(),
                noticeWaiveStatus: noticeWaive,
                noticeWaiveRemark: noticeWaiveRemark.toString(),
                finalCreatedDate: moment(resignationDate).format('YYYY-MM-DD'),
                finalCreatedDateRemark: editFinalCreatedDateRemark.toString(),
            };
            axios
                .post(url, resignationApprovaldetails)
                .then(
                    (response) => alert('Resignation has been countered!'),
                    setTimeout(() => {
                        history.push('/resignation');
                        window.location.reload();
                    }, 1000)
                )
                .catch((err) => console.error(err));
        }
    };

    const returntoresignationtable = () => {
        history.push('/resignation');
    }

    const resubmitResignation = async (resubmit) => {
        //!====== hidden console.log()
        // console.log(formID);
        // console.log(resubmit.rejectRemark);
        const adminresubmitRemark = resubmit.rejectRemark;

        const url = REACT_APP_API_BACKEND_URL + "/api/resignation/updateresignation";
        const resignationStatusDetails = {
            formStatus: 5,
            rejectRemark: adminresubmitRemark,
            formID: formID,

        };
        try {
            const response = await axios.post(url, resignationStatusDetails, {
                headers: {
                    "Authorization": `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                },
            });
            if (response) {
                alert('The staff details updated successfully!');
                history.push('/resignation');
                sendnoti({
                    adminresubmitRemark,
                    notiToken,
                })
                window.location.reload();
            }
        } catch (error) {
            console.error('An unexpected error occurred:', error);
        }


        //!===================================
        // const monthlist = monthArray.toString();
        // const salarylist = basicSalaryArray.toString();
        // const adminresubmitRemark = resubmit.rejectRemark;
        // let finalworkingdate = "";
        // let resubmitNoticeWaiveStatus = "";
        // if (shortNoticeGiven) {
        //     finalworkingdate = moment(lastWorkingDate).format('YYYY-MM-DD');
        // }
        // if (noticeWaive) {
        //     resubmitNoticeWaiveStatus = noticeWaive;
        // }
        // const url =
        //     REACT_APP_API_BACKEND_URL + '/api/resignation/resignresubmit';

        // const resubmitDetails = {
        //     updatedBy: currentUserID,
        //     formID: formID,
        //     formStatus: 5,
        //     counterStatus: counter,
        //     counterValue: counterValue,
        //     counterRemark: counterRemark.toString(),
        //     lastSalaryDate: moment(lastDrawnSalaryDate).format('YYYY-MM-DD'),
        //     lastSalaryDateRemark: editLastSalaryRemark.toString(),
        //     lastWorkDate: moment(resignationDatewithNoticeV2).format('YYYY-MM-DD'),
        //     lastWorkDateEmployee: finalworkingdate,
        //     lastWorkDateRemark: lastWorkDateEmp.toString(),
        //     basicSalary: salarylist,
        //     basicSalaryRemark: editBasicSalaryRemark.toString(),
        //     month: monthlist,
        //     shortDay: shortNoticeTrue.toString(),
        //     lastPhysicalDate: moment(lastPhysicalWorkingDate).format('YYYY-MM-DD'),
        //     lastPhysicalDateRemark: editLastWorkingDayRemark.toString(),
        //     noticeWaiveStatus: resubmitNoticeWaiveStatus,
        //     noticeWaiveRemark: noticeWaiveRemark.toString(),
        //     rejectRemark: adminresubmitRemark,
        // };
        // console.log(url);
        // console.log(JSON.stringify(resubmitDetails, null, 2));
        // axios
        //     .post(url, resubmitDetails)
        //     .then((response) => {
        //         if (response.data.name == "Error") {
        //             alert('An error has occured while approving this form please try again.');
        //             setTimeout(() => {
        //                 // history.push('/resignation');
        //                 // window.location.reload();
        //             }, 1000)
        //         }
        //         else {
        //             if (notiToken) {
        //                 sendnoti({
        //                     adminresubmitRemark,
        //                     notiToken,
        //                 })
        //             }
        //         }
        //     })
        //     .catch((err) => console.error(err));
    };

    const sendnoti = async (noti) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/resubmitnoti';
        const notiInfo = {
            rejectRemark: noti.adminresubmitRemark,
            notiToken: noti.notiToken,
        };
        axios
            .post(url, notiInfo)
            .then(
                (response) =>
                    alert('Resignation form has been set to resubmission!'),
                setTimeout(() => {
                    setResubmitModal(!resubmitModal);
                }, 500),
                setTimeout(() => {
                    history.push('/resignation');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const deleteResign = async () => {
        if (!window.confirm('Do you want to delete this resignation form?')) {
            return false;
        }
        const monthlist = monthArray.toString();
        const salarylist = basicSalaryArray.toString();
        let finalworkingdate = "";
        let rejectNoticeWaiveStatus = "";
        if (shortNoticeGiven) {
            finalworkingdate = moment(lastWorkingDate).format('YYYY-MM-DD');
        }
        if (noticeWaive) {
            rejectNoticeWaiveStatus = noticeWaive;
        }
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/resigndelete';
        const resignationApprovaldetails = {
            updatedBy: currentUserID,
            formID: formID,
            formStatus: currentFormStatus,
            counterStatus: counter,
            counterValue: counterValue,
            counterRemark: counterRemark.toString(),
            lastSalaryDate: moment(lastDrawnSalaryDate).format('YYYY-MM-DD'),
            lastSalaryDateRemark: editLastSalaryRemark.toString(),
            lastWorkDate: moment(resignationDatewithNoticeV2).format('YYYY-MM-DD'),
            lastWorkDateEmployee: finalworkingdate,
            lastWorkDateRemark: lastWorkDateEmp.toString(),
            basicSalary: salarylist,
            basicSalaryRemark: editBasicSalaryRemark.toString(),
            month: monthlist,
            shortDay: shortNoticeTrue.toString(),
            lastPhysicalDate: moment(lastPhysicalWorkingDate).format('YYYY-MM-DD'),
            lastPhysicalDateRemark: editLastWorkingDayRemark.toString(),
            noticeWaiveStatus: rejectNoticeWaiveStatus,
            noticeWaiveRemark: noticeWaiveRemark.toString(),
        };
        //!====== hidden console.log()
        // console.log("Delete Resignation Details Hereee!!");
        // console.log(resignationApprovaldetails);
        axios
            .post(url, resignationApprovaldetails)
            .then((response) => {
                if (response.data.name == "Error") {

                    alert('An error has occured while deleting this form please try again.');
                    setTimeout(() => {
                        history.push('/resignation');
                        window.location.reload();
                    }, 1000)
                }
                else {
                    alert('Resignation has been deleted!');
                    history.push('/resignation');
                    window.location.reload();
                }
            })
            .catch((err) => console.error(err));
    };

    const revertHR = async () => {
        if (!window.confirm('Do you want to change the status of this form back to Pending HR?')) {
            return false;
        }
        const url =
            REACT_APP_API_BACKEND_URL + '/api/resignation/revertHR';
        const resignationApprovaldetails = {
            updatedBy: currentUserID,
            formID: formID,
            formStatus: currentFormStatus,
        };
        axios
            .post(url, resignationApprovaldetails)
            .then((response) => {
                if (response.data.name == "Error") {
                    alert('An error has occured while changing the status of this form please try again.');
                    setTimeout(() => {
                        history.push('/resignation');
                        window.location.reload();
                    }, 1000)
                }
                else {
                    alert('Resignation form has been reverted to Pending HR!');
                    history.push('/resignation');
                    window.location.reload();
                }
            })
            .catch((err) => console.error(err));
    };
    async function handleRejoin() {
        const isConfirmed = window.confirm('Do you want to change the status of this staff to rejoin?');
        if (isConfirmed) {
            const url = REACT_APP_API_BACKEND_URL + "/api/resignation/updateresignation";
            const rejoinDetails = {
                formStatus: 6,  // Rejoin
                rejectRemark: "",
                formID: formID
            };
            try {
                const response = await axios.post(url, rejoinDetails, {
                    headers: {
                        "Authorization": `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    },
                });
                if (response) {
                    alert('The staff details updated successfully!');
                    history.push('/resignation');
                    window.location.reload();
                }
            } catch (error) {
                console.error('An unexpected error occurred:', error);
            }
        }
    };

    async function updateSuperiorName() {
        if (superiorBadgeid) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/updatesuperiorname';

            const details = {
                superior: superiorBadgeid,
                formID: formID,
            }
            axios
                .post(url, details)
                .then((response) => {
                    if (response.data.statusCode === 0) {
                        updateSuperiorName();
                    }
                    else if(response.data.statusCode == 1){
                        history.push('/resignation');
                        alert('Superior name successfully updated!')
                        console.log("Superior name successfully updated!");
                    }
                })
                .catch((err) => console.error(err));
        }
    }

    // to handle update superior dialog
    const handleChgSuperiorOpenDialog = () => {
        //!====== hidden console.log()
        // console.log("open chg superior dialog")
        // console.log(superiorName);
        setSuperiorName(superiorName);
        setOpenChgSuperiorDialog(true);
    };

    const handleCloseChgSuperiorDialog = () => {
        getSuperiorDetails(superiorName);
        updateSuperiorName();
        setOpenChgSuperiorDialog(false);
    };


    // get the superior details and set it 
    const getSuperiorDetails = (userProp) => {
        if (userProp) {
            setSuperiorName(userProp.label);
            setSuperiorBadgeId(userProp.value)
            console.log(userProp)
        }
        else {
            setSuperiorName('');
            setSuperiorBadgeId('');
        }
    }

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container' id="divToPrint">
                    <div className={`${props.isActive ? 'container is-active' : 'container-fluid'}`}>
                        <div style={{ justifyContent: 'space-between', display: 'flex' }}>
                            <button className='btn-primary' onClick={returntoresignationtable}>Back</button>
                            <div>
                                <button className='btn-primary' onClick={handleRejoin}>Rejoin</button>
                                <button className='btn-primary' style={{ marginLeft: '20px' }} onClick={deleteResign}>Delete</button>
                                {(currentFormStatus != 5 && <button className='btn-primary' style={{ marginLeft: '20px' }} onClick={handleResubmitModal}>Resubmit</button>)}
                                <ResubmitModal
                                    show={resubmitModal}
                                    handleClose={handleResubmitModal}
                                    onAdd={resubmitResignation}
                                />
                            </div>
                        </div>
                        <div className='jumbotron text-center'>
                            PAYMENT IN LIEU OF NOTICE CALCULATION
                        </div>
                        <div className='row resignationbg'>
                            <div style={{ marginTop: '1%' }}></div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Staff Name</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} value={applicantName} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Employee ID</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' value={applicantID} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Position</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' value={applicantPosition} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Date Joined</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' value={moment(applicantHireDate).format("DD/MM/YYYY")} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Grade</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' value={applicantPayGrade} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Length of Service</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' value={applicantServiceLength} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Payroll Factory</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <input type="text" className='resignationinputdesign' value={applicantPayrollFactory} readOnly />
                            </div>
                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Actual Work Location</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <input type="text" className='resignationinputdesign' value={applicantWorkLocation} readOnly />
                            </div>

                            <div className='col-sm-2 mb-4 resignationlabeldesign'>Superior Name</div>
                            <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <input type="text" className='resignationsuperiorinputdesign' style={{ width: currentFormStatus == 1 || currentFormStatus == 2 ? "80%" : "85%" }} value={superiorName} readOnly />
                                <img
                                    src={EditIcon}
                                    className='edit-icon'
                                    onClick={handleChgSuperiorOpenDialog}
                                    alt=''
                                />
                            </div>

                            <Modal show={openChgSuperiorDialog} onHide={handleCloseChgSuperiorDialog}>
                                <div className="modal-title">
                                    <Modal.Title style={{ marginBottom: '0px' }}>Update Superior</Modal.Title>
                                </div>
                                <div className="dropDown-superiorName">
                                    <SearchUserByEC
                                        getSuperiorDetails={getSuperiorDetails}
                                        token={props.cognitoToken.idToken.jwtToken}
                                        hodUsername={superiorUserName}
                                        style={{ textTransform: 'capitalize' }} required />
                                </div>
                                <div className="modal-button" >
                                    <Button variant="primary" onClick={handleCloseChgSuperiorDialog}>
                                        Update
                                    </Button>

                                </div>
                            </Modal>
                            <div style={{ display: currentFormStatus == 2 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }} className='col-sm-2 mb-4 resignationlabeldesign'>Counter</div>
                            {(currentFormStatus == 2 && <div className='col-sm-4 mb-4' style={{ display: 'flex' }}>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <Select
                                    className='resignationcounter'
                                    placeholder={'Select a value'}
                                    styles={customStyles}
                                    onChange={handleChangeCounter}
                                    options={optionCounter}
                                    isClearable
                                    isSearchable={false}
                                    value={selectedOption}
                                />
                            </div>)}
                            <div className='col-sm-4 mb-4' style={{ display: currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <input type="text" className='resignationinputdesign' value={counterText} readOnly />
                            </div>
                            {(counter == 1 && <div className='col-sm-2 mb-4 resignationlabeldesign'>Counter Value</div>)}
                            {(counter == 1 && <div className='col-sm-4 mb-4'>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <input type="text" placeholder='Insert counter value here...' className='resignationinputdesign' style={{ display: currentFormStatus == 2 ? "inline" : "none" }} value={counterValue} onChange={updateCounterValue} />
                                <input type="text" className='resignationinputdesign' style={{ display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "inline" : "none" }} value={counterValue} readOnly />
                            </div>)}
                            {(counterRemarkStatus && <div className='col-sm-2 mb-4 resignationlabeldesign'>Counter Remark</div>)}
                            {(counterRemarkStatus && <div className='col-sm-4 mb-4' style={{ display: 'flex' }}>
                                <span style={{ marginRight: '2%' }}>:</span>
                                <textarea rows="3" cols="21"
                                    placeholder='Insert remark on changes made to counter here...'
                                    className='counterremarkbox resignationcounter'
                                    style={{ width: '96.2%', resize: "none", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                    defaultValue={counterRemark}
                                    onChange={(e) => setCounterRemark(e.target.value)}
                                    readOnly
                                />
                                <textarea rows="3" cols="21"
                                    className='counterremarkbox'
                                    placeholder='Insert remark on changes made to counter here...'
                                    style={{ width: '96.2%', resize: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                    defaultValue={counterRemark}
                                    onChange={(e) => setCounterRemark(e.target.value)}
                                />
                            </div>)}
                            <div className='col-sm-12 mb-4'>
                                <div className='row'>
                                    <div className='col-sm-2 mb-4 resignationlabelAttachmentdesign'>Resignation Letter</div>
                                    <div className='col-sm-10 mb-4 resignationlabeldesign'>
                                        <span style={{ marginRight: '1.45%' }}>:</span>
                                        <img
                                            src={DownloadIcon}
                                            className='table-icon'
                                            style={{ maxWidth: '60px' }}
                                            onClick={() => { downloadFile() }}
                                            alt=''
                                        />
                                    </div>
                                </div>
                            </div>
                            {(currentFormStatus == 5 && <div className='col-sm-2 mb-4'>
                                Resubmission Remark
                            </div>)}
                            {(currentFormStatus == 5 && <div className='col-sm-10 mb-4' style={{ display: 'flex' }}>
                                <span style={{ marginRight: '2%' }}>:</span>
                                <textarea rows="3" cols="21"
                                    className='counterremarkbox'
                                    style={{ width: '96.2%', resize: "none" }}
                                    defaultValue={resubmittedRemark}
                                    readOnly
                                />
                            </div>)}

                            {/* Short Notice field */}
                            <div className='row'>
                                <div style={{ display: "block" }} className='col-sm-2 mb-4 resignationlabeldesign'>Short Notice</div>
                                <div className='col-sm-4 mb-4' style={{ display: 'flex' }}>
                                    <span className='resignationdoublecolonspacing'>:</span>
                                    {(!editStatus &&
                                        <input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} value={shortNoticeGiven == 0 ? 'No' : shortNoticeGiven == 1 ? "Yes" : '24 hours resignation'} readOnly />)}

                                    {(editStatus && <Select
                                        className="resignationcounter"
                                        placeholder={"Please select an option"}
                                        styles={customStyles}
                                        onChange={handleShortNoticeUpdate}
                                        options={shortNoticeOption}
                                        isSearchable={false}
                                        value={newShortNoticeDisplay}
                                    />)}
                                </div>
                            </div>

                            {/* Short Notice Payment */}
                            {(!editStatus && shortNoticeGiven != "" && (<div className='row'>
                                <div style={{ display: "block" }} className='col-sm-2 mb-4 resignationlabeldesign'>Short Notice Payment</div>
                                <div className='col-sm-4 mb-4' style={{ display: 'flex' }}>
                                    <span className='resignationdoublecolonspacing'>:</span>
                                    <input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} value={shortNoticePaymentName} readOnly />
                                </div>
                            </div>))}

                            {(editStatus && openShortNoticePayment && <div className='row'>
                                <div style={{ display: "block" }} className='col-sm-2 mb-4 resignationlabeldesign'>Short Notice Payment</div>
                                <div className='col-sm-4 mb-4' style={{ display: 'flex' }}>
                                    <span className='resignationdoublecolonspacing'>:</span>

                                    <Select
                                        className="resignationcounter"
                                        placeholder={"Please select an option"}
                                        styles={customStyles}
                                        onChange={handleShortNoticePaymentUpdate}
                                        options={shortNoticePaymentList}
                                        isSearchable={false}
                                        value={shortNoticePaymentList.label}
                                    />
                                </div>
                            </div>)}

                            {/* Leave Utilized Field */}
                            <div className='row'>
                                <div className='col-sm-2 mb-4 resignationlabeldesign' style={{ display: "block" }}>Leave Utilised</div>
                                <div className='col-sm-4 mb-4' >
                                    <span className='resignationdoublecolonspacing'>:</span>
                                    <input
                                        type="text"
                                        step="0.05"
                                        className='resignationinputdesign'
                                        style={{ textTransform: 'capitalize' }}
                                        value={leaveDays}
                                        onChange={handleUpdateLeaveDays}
                                        readOnly={!leaveUtilisedEditable}
                                        required={leaveUtilisedEditable} />
                                </div>
                            </div>

                            {/* Small Table here */}
                            <div className="table-responsive">
                                <table className="table table-bordered resignationtable">
                                    <thead>
                                        <tr>
                                            <th className='resignationtableNoHeader'>No.</th>
                                            <th colSpan="6" className='resignationtableDetailHeader'>Details</th>
                                        </tr>
                                    </thead>
                                    {((shortNoticeGiven == 1 || shortNoticeGiven == 2) && <tbody>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>1</th>
                                            <td colSpan="2" className='resignationtableLabel'>Resignation Letter Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(resignationDate).format('DD/MM/YYYY')}</td>)}
                                            {(editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>
                                                {/* <input type="date" value={moment(resignationDate).format('YYYY-MM-DD')} onChange={updateSubmissionDate}/> */}
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(resignationDate).format('YYYY/MM/DD'))}
                                                    onChange={updateSubmissionDate}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>)}
                                        </tr>
                                        {(editFinalCreatedDateStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Resignation Letter Date Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to resignation letter date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={editFinalCreatedDateRemark}
                                                    onChange={(e) => setEditFinalCreatedDateRemark(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to resignation letter date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={editFinalCreatedDateRemark}
                                                    onChange={(e) => setEditFinalCreatedDateRemark(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>2</th>
                                            <td colSpan="2" className='resignationtableLabel'>Short Notice</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{shortNoticeTrue} days + ({leaveDays} days of offset leaves)</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>3</th>
                                            <td colSpan="6">Duration of notice period</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td scope="row" className='resignationtableNoContent'>(a)</td>
                                            <td className='resignationtableLabel'>Month/Week</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(noticePeriodMonth && <td colSpan="3" className="resignationtableContent resignationtablenoedit" style={{ backgroundColor: "#f9f9f9" }}>{noticePeriod} months</td>)}
                                            {(!noticePeriodMonth && <td colSpan="3" className="resignationtableContent resignationtablenoedit" style={{ backgroundColor: "#f9f9f9" }}>{noticePeriod} weeks</td>)}
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td className='resignationtableNoContent'>(b)</td>
                                            <td className='resignationtableLabel'>Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td className="resignationtableSubContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(resignationDate).format('DD/MM/YYYY')}</td>
                                            <td className="resignationtableSubContent2" style={{ backgroundColor: "#f9f9f9" }}>to</td>
                                            <td className="resignationtableSubContent" style={{ backgroundColor: "#f9f9f9" }}>{resignationDatewithNotice}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>4</th>
                                            <td colSpan="2" className='resignationtableLabel'>Requested Last Day by Employee</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastWorkingDate).format('DD/MM/YYYY')}</td>)}
                                            {(editStatus && <td colSpan="3" className="resignationtableContent">
                                                {/* <input type="date" value={moment(lastWorkingDate).format('YYYY-MM-DD')} onChange={updateLastWorkDateEmp}/> */}
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(lastWorkingDate).format('YYYY/MM/DD'))}
                                                    onChange={updateLastWorkDateEmp}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>)}
                                        </tr>
                                        {(lastWorkDateEmpStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Requested Last Day by Employee Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to requested last day by employee here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={lastWorkDateEmp}
                                                    onChange={(e) => setLastWorkDateEmp(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to requested last day by employee here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={lastWorkDateEmp}
                                                    onChange={(e) => setLastWorkDateEmp(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>5</th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Physical Working Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastPhysicalWorkingDate).format('DD/MM/YYYY')}<span style={{ display: lastphysicalSaturday ? "inline" : "none", marginLeft: "15px" }}>({applicantSaturdayGroup})</span></td>)}
                                            {(editStatus && <td colSpan="3" className="resignationtableContent">
                                                {/* <input type="date" value={moment(lastPhysicalWorkingDate).format('YYYY-MM-DD')} onChange={updateLastWorkingDate}/> */}
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(lastPhysicalWorkingDate).format('YYYY/MM/DD'))}
                                                    onChange={updateLastWorkingDate}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>)}
                                        </tr>
                                        {(editLastWorkingDayStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Physical Working Date Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to last physical working date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={editLastWorkingDayRemark}
                                                    onChange={(e) => setEditLastWorkingDayRemark(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to last physical working date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={editLastWorkingDayRemark}
                                                    onChange={(e) => setEditLastWorkingDayRemark(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>6</th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Drawn Salary Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastDrawnSalaryDate).format('DD/MM/YYYY')}<span style={{ display: lastdrawnSalarySaturday ? "inline" : "none", marginLeft: "15px" }}>({applicantSaturdayGroup})</span></td>)}
                                            {(editStatus && <td colSpan="3" className="resignationtableContent">
                                                {/* <input type="date" value={moment(lastDrawnSalaryDate).format('YYYY-MM-DD')} onChange={updateLastDrawnSalary}/> */}
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(lastDrawnSalaryDate).format('YYYY/MM/DD'))}
                                                    onChange={updateLastDrawnSalary}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>)}
                                        </tr>
                                        {(editLastSalaryRemarkStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Drawn Salary Date Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to last drawn salary date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={editLastSalaryRemark}
                                                    onChange={(e) => setEditLastSalaryRemark(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to last drawn salary date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={editLastSalaryRemark}
                                                    onChange={(e) => setEditLastSalaryRemark(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>7</th>
                                            <td colSpan="2" className='resignationtableLabel'>Basic Salary [RM]</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{applicantSalary}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>8</th>
                                            <td colSpan="6" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Payment in Lieu of Notice</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td scope="row" className='resignationtableNoContent'>(a)</td>
                                            <td className='resignationtableLabel'>Number of Days</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{shortNoticeTrue}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="7">
                                                <table className="table table-bordered resignationtable2">
                                                    <thead>
                                                        <tr>
                                                            <th className='resignationtable2align'>Month</th>
                                                            <th className='resignationtable2align'>Basic Salary [RM]</th>
                                                            <th className='resignationtable2align'>No. of Days in the Month</th>
                                                            <th className='resignationtable2align'>No. of Short Days</th>
                                                            <th className='resignationtable2align'>Total [RM]</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {tableInfoList?.map((tableInfoList, index) =>
                                                            <tr>
                                                                <td scope="row" className='resignationtable2align' style={{ backgroundColor: "#f9f9f9" }}>{tableInfoList.month}</td>
                                                                {(!editStatus && <td className='resignationtable2align' style={{ backgroundColor: "#f9f9f9" }}>{parseFloat(tableInfoList.basic_salary).toFixed(2)}</td>)}
                                                                {(editStatus && <td className='resignationtable2align'>
                                                                    <input type="text" value={tableInfoList.basic_salary} onChange={updateBasicSalary(index)} />
                                                                </td>)}
                                                                <td className='resignationtable2align' style={{ backgroundColor: "#f9f9f9" }}>{tableInfoList.month_day}</td>
                                                                <td className='resignationtable2align' style={{ backgroundColor: "#f9f9f9" }}>{tableInfoList.short_day}</td>
                                                                <td className='resignationtable2align' style={{ backgroundColor: "#f9f9f9" }}>{tableInfoList.total}</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="3" style={{ textAlign: 'end' }}>Grand Total</th>
                                                            <th className='resignationtable2align' style={{ color: '#e31e1e', backgroundColor: "#f9f9f9" }}>{shortNoticeTrue}</th>
                                                            <th className='resignationtable2align' style={{ color: '#e31e1e', backgroundColor: "#f9f9f9" }}>{deductionTotal}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </td>
                                        </tr>
                                        {(editBasicSalaryRemarkStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Basic Salary Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to basic salary here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={editBasicSalaryRemark}
                                                    onChange={(e) => setEditBasicSalaryRemark(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to basic salary here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={editBasicSalaryRemark}
                                                    onChange={(e) => setEditBasicSalaryRemark(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>9</th>
                                            <td colSpan="2" className='resignationtableLabel'>Amount Owe to the Company [RM]</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!noticeWaiveRemarkStatus && <th colSpan="3" className="resignationtableContent" style={{ color: '#e31e1e', backgroundColor: "#f9f9f9" }}>{deductionTotal}</th>)}
                                            {(noticeWaiveRemarkStatus && <th colSpan="3" className="resignationtableContent" style={{ color: '#e31e1e', backgroundColor: "#f9f9f9" }}>0 (Notice Waive Selected: Yes)</th>)}
                                        </tr>
                                    </tbody>)}
                                    {(shortNoticeGiven == 0 && <tbody>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>1</th>
                                            <td colSpan="2" className='resignationtableLabel'>Resignation Letter Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(resignationDate).format('DD/MM/YYYY')}</td>)}
                                            {(editStatus && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>
                                                {/* <input type="date" value={moment(resignationDate).format('YYYY-MM-DD')} onChange={updateSubmissionDate}/> */}
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(resignationDate).format('YYYY/MM/DD'))}
                                                    onChange={updateSubmissionDate}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>)}
                                        </tr>
                                        {(editFinalCreatedDateStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Resignation Letter Date Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to resignation letter date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={editFinalCreatedDateRemark}
                                                    onChange={(e) => setEditFinalCreatedDateRemark(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to resignation letter date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={editFinalCreatedDateRemark}
                                                    onChange={(e) => setEditFinalCreatedDateRemark(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>2</th>
                                            <td colSpan="6">Duration of notice period</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td scope="row" className='resignationtableNoContent'>(a)</td>
                                            <td className='resignationtableLabel'>Month/Week</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(noticePeriodMonth && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{noticePeriod} months</td>)}
                                            {(!noticePeriodMonth && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{noticePeriod} weeks</td>)}
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td className='resignationtableNoContent'>(b)</td>
                                            <td className='resignationtableLabel'>Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td className="resignationtableSubContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(resignationDate).format('DD/MM/YYYY')}</td>
                                            <td className="resignationtableSubContent2" style={{ backgroundColor: "#f9f9f9" }}>to</td>
                                            <td className="resignationtableSubContent" style={{ backgroundColor: "#f9f9f9" }}>{resignationDatewithNotice}</td>
                                            {/* <td className="resignationtableSubContent"><input type="text"  placeholder='Submission Date + 3(a) days' className='resignationtableinputdesign' value={shortNotice} onChange={(e) => setShortnotice(e.target.value)}/></td> */}
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>3</th>
                                            <td colSpan="2" className='resignationtableLabel'>Requested Last Day by Employee</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(lastWorkingDate != '1/1/0001 12:00:00 AM' && !editStatus) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastWorkingDate).format('DD/MM/YYYY')}</td>}
                                            {(lastWorkingDate == '1/1/0001 12:00:00 AM' && !editStatus) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastPhysicalWorkingDate).format('DD/MM/YYYY')}</td>}
                                            {(lastWorkingDate != '1/1/0001 12:00:00 AM' && editStatus) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(lastWorkingDate).format('YYYY/MM/DD'))}
                                                    onChange={updateLastWorkDateEmp}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>}
                                            {(lastWorkingDate == '1/1/0001 12:00:00 AM' && editStatus) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(lastPhysicalWorkingDate).format('YYYY/MM/DD'))}
                                                    onChange={updateLastWorkDateEmp}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>}
                                        </tr>
                                        {(lastWorkDateEmpStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Requested Last Day by Employee Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to requested last day by employee here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={lastWorkDateEmp}
                                                    onChange={(e) => setLastWorkDateEmp(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to requested last day by employee here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={lastWorkDateEmp}
                                                    onChange={(e) => setLastWorkDateEmp(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>4</th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Physical Working Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastPhysicalWorkingDate).format('DD/MM/YYYY')}<span style={{ display: lastphysicalSaturday ? "inline" : "none", marginLeft: "15px" }}>({applicantSaturdayGroup})</span></td>
                                        </tr>
                                        {/* <tr>
                                        <th scope="row" className='resignationtableNoContent'>5</th>
                                        <td colSpan="2" className='resignationtableLabel'>Last Drawn Salary Date</td>
                                        <td className='resignationtableSemicolon'>:</td>
                                        <td colSpan="3" className="resignationtableContent" style={{backgroundColor:"#f9f9f9"}}>{resignationDatewithNotice}</td>
                                        </tr> */}
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>5</th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Drawn Salary Date</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            {(!editStatus && location.state.rowData.lastSalaryDateAdminRemark == "" && (location.state.rowData.formStatusID == 3 || location.state.rowData.formStatusID == 4)) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{resignationDatewithNotice}</td>}
                                            {(!editStatus && location.state.rowData.lastSalaryDateAdminRemark != "" && (location.state.rowData.formStatusID == 3 || location.state.rowData.formStatusID == 4)) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastDrawnSalaryDate).format('DD/MM/YYYY')}</td>}
                                            {(!editStatus && (location.state.rowData.formStatusID == 1 || location.state.rowData.formStatusID == 2 || location.state.rowData.formStatusID == 5)) && <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{moment(lastDrawnSalaryDate).format('DD/MM/YYYY')}</td>}
                                            {(editStatus && <td colSpan="3" className="resignationtableContent">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={new Date(moment(lastDrawnSalaryDate).format('YYYY/MM/DD'))}
                                                    onChange={updateLastDrawnSalary}
                                                    onKeyDown={(e) => { e.preventDefault(); }}
                                                />
                                            </td>)}
                                        </tr>
                                        {(editLastSalaryRemarkStatus && <tr>
                                            <th scope="row" className='resignationtableNoContent'></th>
                                            <td colSpan="2" className='resignationtableLabel'>Last Drawn Salary Date Edit Remark</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className='resignationtableLabel'>
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to last drawn salary date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", backgroundColor: "#f9f9f9", display: currentFormStatus == 1 || currentFormStatus == 3 || currentFormStatus == 4 || currentFormStatus == 5 ? "block" : "none" }}
                                                    defaultValue={editLastSalaryRemark}
                                                    onChange={(e) => setEditLastSalaryRemark(e.target.value)}
                                                    readOnly
                                                />
                                                <textarea rows="3" cols="21"
                                                    className='resignationRemarkTextBox'
                                                    placeholder='Insert remark on changes made to last drawn salary date here...'
                                                    style={{ width: '100%', resize: "none", border: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                                    defaultValue={editLastSalaryRemark}
                                                    onChange={(e) => setEditLastSalaryRemark(e.target.value)}
                                                />
                                            </td>
                                        </tr>)}
                                        <tr></tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>6</th>
                                            <td colSpan="2" className='resignationtableLabel'>Basic Salary [RM]</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{applicantSalary}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" className='resignationtableNoContent'>7</th>
                                            <td colSpan="2" className='resignationtableLabel'>Amount Owe to the Company [RM]</td>
                                            <td className='resignationtableSemicolon'>:</td>
                                            <td colSpan="3" className="resignationtableContent" style={{ backgroundColor: "#f9f9f9" }}>{deductionTotal}</td>
                                        </tr>
                                    </tbody>)}
                                </table>
                            </div>

                            {(shortNoticeGiven != "" && <div style={{ display: currentFormStatus == 2 || currentFormStatus == 3 || currentFormStatus == 4 ? "inline" : "none" }} className='col-sm-2 mb-4 resignationlabeldesign'>Notice Waive</div>)}
                            {((currentFormStatus == 2 && shortNoticeGiven != "") && <div className='col-sm-4 mb-4' style={{ display: 'flex' }}>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <Select
                                    className='resignationcounter'
                                    placeholder={'Select whether to waive payment'}
                                    styles={customStyles}
                                    onChange={handleChangeWaive}
                                    options={optionCounter}
                                    isClearable
                                    isSearchable={false}
                                    value={selectedWaive}
                                />
                            </div>)}
                            {(shortNoticeGiven != "" && <div className='col-sm-4 mb-4' style={{ display: currentFormStatus == 3 || currentFormStatus == 4 ? "block" : "none" }}>
                                <span className='resignationdoublecolonspacing'>:</span>
                                <input type="text" className='resignationinputdesign' value={noticeWaiveText} readOnly />
                            </div>)}
                            <div className='col-sm-6 mb-2'></div>
                            {(noticeWaiveRemarkStatus && <div className='col-sm-2 mb-4 resignationlabeldesign'>Notice Waive Remark</div>)}
                            {(noticeWaiveRemarkStatus && <div className='col-sm-10 mb-4' style={{ display: 'flex' }}>
                                <span style={{ marginRight: '2%' }}>:</span>
                                <textarea rows="3" cols="21"
                                    placeholder='Insert remark on changes made to  here...'
                                    className='counterremarkbox'
                                    style={{ width: '96.2%', resize: "none", display: currentFormStatus == 3 || currentFormStatus == 4 ? "block" : "none" }}
                                    defaultValue={noticeWaiveRemark}
                                    onChange={(e) => setCounterRemark(e.target.value)}
                                    readOnly
                                />
                                <textarea rows="3" cols="21"
                                    placeholder='Insert remark on changes made to counter here...'
                                    style={{ width: '96.2%', resize: "none", display: currentFormStatus == 2 ? "block" : "none" }}
                                    defaultValue={noticeWaiveRemark}
                                    onChange={(e) => setNoticeWaiveRemark(e.target.value)}
                                />
                            </div>)}
                            <div className='col-sm-6 mb-2'></div>
                            {(!editStatus && <div>
                                {(currentFormStatus == 2 && <div>
                                    <Button style={{ float: "left" }} as='input' type='button' value='Edit' onClick={startEdit} />
                                    <Button style={{ float: "right", marginLeft: "20px" }} as='input' type='button' value='Counter' onClick={counterResign} />
                                    <Button style={{ float: "right" }} as='input' type='button' value='Approve' onClick={approvalPDF} />
                                </div>)}
                            </div>)}
                            {(editStatus && <div>
                                {(currentFormStatus == 2 && <div>
                                    <Button style={{ float: "left" }} as='input' type='button' value='Cancel Edit' onClick={startEdit} />
                                    <Button style={{ float: "right", marginLeft: "20px" }} as='input' type='button' value='Counter' onClick={counterResign} />
                                    <Button style={{ float: "right" }} as='input' type='button' value='Approve' onClick={approvalPDF} />
                                </div>)}
                            </div>)}
                            {(currentFormStatus == 3 || currentFormStatus == 4) && <div>
                                <Button style={{ float: "left" }} as='input' type='button' value='Revert Status to Pending HR' onClick={revertHR} />
                            </div>}
                        </div>
                    </div>
                    <br></br>
                </div>
            )}
        </Fragment>
    );
};

export default ResignationForm;